<template>
    <div class="promoPage">
        <!-- sidenav -->
        <div class="container-fluid">
            <div class="d-lg-none">
                <div id="mySidenav" :style="showNavbar === true ? 'width: 80%; opacity: 1' : 'width: 0; opacity: 0'"
                     class="sidenav d-flex align-items-start flex-column">
                    <div class="mb-auto w-100">
                        <a href="#" class="closebtn" @click="showNavbar = false">&times;</a>
                        <a class="sidenav-link" @click="showNavbar = false, scrollToBottom('forWhom')"
                           style="cursor: pointer"
                        >
                            {{ $t('promoNew.forWhom') }}?
                        </a>
                        <a class="sidenav-link" @click="showNavbar = false, scrollToBottom('price')"
                           style="cursor: pointer"
                        >
                            {{ $t('plan.title') }}
                        </a>
                        <a href="#login" class="sidenav-link"
                           @click="showNavbar = false, showModal('login')">{{ $t('login.title') }}</a>
                        <a href="#signup" @click="showNavbar = false, showModal('signup')"
                           class="sidenav-link">{{ $t('company.create') }}</a>
                    </div>
                    <div class="d-flex flex-column sidenav-link sidenav-contacts pb-3">
                        <a href="#">
                            <span>
                                <PromoLanguageSwitcher/>
                            </span>
                        </a>
                        <a href="tel:+998999367070">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style="margin-right: 14px;"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.75391 6.03236C9.20859 5.90815 9.68437 6.14018 9.86484 6.57611V6.57846L10.8023 8.82846C10.9617 9.21049 10.8516 9.65111 10.5305 9.91361L9.375 10.8581C10.1555 12.5081 11.4914 13.8441 13.1414 14.6246L14.0883 13.4691C14.3484 13.148 14.7914 13.0378 15.1734 13.1972L17.4234 14.1347C17.8594 14.3152 18.0914 14.791 17.9672 15.2456L17.4047 17.3081C17.2922 17.716 16.9219 17.9996 16.5 17.9996C10.7016 17.9996 6 13.298 6 7.49955C6 7.07768 6.28359 6.70736 6.69141 6.59486L8.75391 6.03236Z"
                                    fill="white"/>
                            </svg>
                            <span>&ensp;+998 99 936-70-70</span>
                        </a>
                        <a href="mailto:info@boshqar.com" target="_blank">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style="margin-right: 14px;"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM5.59961 8.4002C5.59961 7.7377 6.13711 7.2002 6.79961 7.2002H17.1996C17.8621 7.2002 18.3996 7.7377 18.3996 8.4002C18.3996 8.7777 18.2221 9.1327 17.9196 9.3602L12.4796 13.4402C12.1946 13.6527 11.8046 13.6527 11.5196 13.4402L6.07961 9.3602C5.77711 9.1327 5.59961 8.7777 5.59961 8.4002ZM5.59961 15.2002V10.0002L11.0396 14.0802C11.6096 14.5077 12.3896 14.5077 12.9596 14.0802L18.3996 10.0002V15.2002C18.3996 16.0827 17.6821 16.8002 16.7996 16.8002H7.19961C6.31711 16.8002 5.59961 16.0827 5.59961 15.2002Z"
                                    fill="white"
                                />
                            </svg>
                            <span>&ensp;info@boshqar.com</span>
                        </a>
                        <a href="https://t.me/boshqarComChat" target="_blank">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style="margin-right: 14px;"
                            >
                                <path
                                    d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM17.5622 8.16097C17.3816 10.0585 16.6002 14.6631 16.2025 16.7884C16.0343 17.6876 15.7031 17.9892 15.3825 18.0186C14.6857 18.0828 14.1564 17.5581 13.4815 17.1157C12.4253 16.4234 11.8287 15.9924 10.8034 15.3168C9.61868 14.5361 10.3867 14.1071 11.0619 13.4055C11.2386 13.222 14.309 10.4292 14.3685 10.1759C14.3759 10.1442 14.383 10.0259 14.3126 9.96373C14.2423 9.9016 14.1389 9.92265 14.0641 9.93953C13.9582 9.9636 12.271 11.0788 9.00247 13.2851C8.5236 13.614 8.08982 13.7742 7.70114 13.7658C7.27268 13.7565 6.4485 13.5236 5.83577 13.3244C5.08427 13.0801 4.48698 12.951 4.539 12.5361C4.5661 12.32 4.86368 12.099 5.43174 11.8732C8.93 10.349 11.2627 9.34421 12.4299 8.85866C15.7624 7.47252 16.4549 7.23174 16.9062 7.22371C17.0055 7.22206 17.2275 7.24664 17.3712 7.36331C17.4668 7.44641 17.5278 7.56238 17.542 7.68827C17.5664 7.84459 17.5731 8.00314 17.5622 8.16097Z"
                                    fill="white"/>
                            </svg>
                            <span>&ensp;Telegram Chat</span>
                        </a>
                    </div>
                    <div class="sidenav-footer d-flex justify-content-around my-4">
                        <div>
                            <a href="https://facebook.com/boshqarCom" target="_blank" class="px-0">
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM17 8.00007C21.9718 8.00007 26 12.0528 26 17.0548C26 21.5742 22.7088 25.3202 18.4062 26.0001V19.6723H20.5031L20.9023 17.0548H18.4062V15.3552C18.4062 14.6393 18.755 13.9412 19.8727 13.9412H21.0079V11.714C21.0079 11.714 19.978 11.5373 18.993 11.5373C16.9365 11.5373 15.5937 12.7907 15.5937 15.0599V17.0548H13.3074V19.6723H15.5937V26.0001C11.2911 25.3202 7.99998 21.5742 7.99998 17.0548C7.99998 12.0528 12.0282 8.00007 17 8.00007Z"
                                          fill="white"/>
                                </svg>
                            </a>
                        </div>
                        <div>
                            <a href="https://instagram.com/boshqarCom" target="_blank" class="px-0">
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM12.3881 16.9999C12.3881 14.4454 14.4481 12.385 17.002 12.385C19.5559 12.385 21.6159 14.4454 21.6159 16.9999C21.6159 19.5544 19.5559 21.6149 17.002 21.6149C14.4481 21.6149 12.3881 19.5544 12.3881 16.9999ZM14.0023 16.9999C14.0023 18.6547 15.3516 20.0003 17.002 20.0003C18.6524 20.0003 20.0017 18.6547 20.0017 16.9999C20.0017 15.3451 18.6564 13.9996 17.002 13.9996C15.3476 13.9996 14.0023 15.3451 14.0023 16.9999ZM21.8047 13.2726C22.399 13.2726 22.8809 12.7946 22.8809 12.1962C22.8809 11.6017 22.399 11.1198 21.8047 11.1198C21.2104 11.1198 20.7285 11.6017 20.7285 12.1962C20.7285 12.7906 21.2063 13.2726 21.8047 13.2726ZM24.4831 9.51717C25.5392 10.5695 25.8685 11.8467 25.9367 13.2887C26.0211 14.7748 26.0211 19.2251 25.9367 20.7112C25.8645 22.1531 25.5352 23.4304 24.4831 24.4827C23.431 25.539 22.154 25.8684 20.7124 25.9367C19.2266 26.021 14.7733 26.021 13.2876 25.9367C11.8459 25.8644 10.573 25.535 9.51689 24.4827C8.46078 23.4304 8.1315 22.1531 8.06324 20.7112C7.97891 19.2251 7.97891 14.7708 8.06324 13.2847C8.13552 11.8427 8.46078 10.5655 9.51689 9.51315C10.573 8.46083 11.85 8.13147 13.2876 8.06319C14.7733 7.97885 19.2266 7.97885 20.7124 8.06319C22.154 8.13549 23.431 8.46484 24.4831 9.51717ZM22.3066 24.0168C23.0977 23.6995 23.7041 23.093 24.0173 22.3057C24.4203 21.2929 24.3978 19.0774 24.3833 17.6412C24.3809 17.403 24.3787 17.1862 24.3787 16.9999C24.3787 16.8136 24.3809 16.5969 24.3833 16.3587C24.3978 14.9233 24.4202 12.7104 24.0173 11.6941C23.7 10.9029 23.0937 10.2964 22.3066 9.98309C21.2908 9.5822 19.0651 9.60356 17.6297 9.61733C17.3968 9.61957 17.1847 9.6216 17.002 9.6216C16.8157 9.6216 16.599 9.6194 16.3609 9.61699C14.9258 9.60245 12.7134 9.58003 11.6974 9.98309C10.9063 10.3004 10.2999 10.9069 9.98672 11.6941C9.58592 12.7101 9.60727 14.9364 9.62104 16.3721C9.62328 16.6051 9.62531 16.8172 9.62531 16.9999C9.62531 17.1863 9.62311 17.403 9.6207 17.6412C9.60616 19.0766 9.58375 21.2895 9.98672 22.3057C10.3039 23.097 10.9103 23.7035 11.6974 24.0168C12.7132 24.4177 14.9389 24.3963 16.3743 24.3825C16.6072 24.3803 16.8193 24.3783 17.002 24.3783C17.1883 24.3783 17.405 24.3805 17.6431 24.3829C19.0782 24.3974 21.2906 24.4198 22.3066 24.0168Z"
                                          fill="white"/>
                                </svg>
                            </a>
                        </div>
                        <div>
                            <a href="https://t.me/boshqarCom" target="_blank" class="px-0">
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM7.99999 16.9999C7.99999 12.0294 12.0294 7.99993 17 7.99993C21.9706 7.99993 26 12.0294 26 16.9999C26 21.9705 21.9706 25.9999 17 25.9999C12.0294 25.9999 7.99999 21.9705 7.99999 16.9999ZM20.1519 20.5912C20.4501 18.9973 21.0362 15.5438 21.1716 14.1207C21.1798 14.0023 21.1748 13.8834 21.1565 13.7661C21.1458 13.6717 21.1001 13.5847 21.0284 13.5224C20.9206 13.4349 20.7541 13.4165 20.6796 13.4177C20.3411 13.4237 19.8218 13.6043 17.3224 14.6439C16.447 15.0081 14.6975 15.7617 12.0738 16.9048C11.6477 17.0742 11.4246 17.2399 11.4042 17.402C11.3699 17.6759 11.7129 17.7837 12.18 17.9306C12.2435 17.9506 12.3093 17.9713 12.3768 17.9932C12.8364 18.1426 13.4545 18.3173 13.7758 18.3243C14.0674 18.3306 14.3927 18.2104 14.7518 17.9638C17.2033 16.309 18.4687 15.4726 18.5481 15.4546C18.6042 15.4419 18.6817 15.4261 18.7344 15.4727C18.7872 15.5193 18.7819 15.6081 18.7763 15.6318C18.7424 15.7767 17.3959 17.0285 16.6991 17.6762C16.482 17.8781 16.3279 18.0213 16.2964 18.0541C16.2258 18.1274 16.1538 18.1969 16.0847 18.2636C15.6578 18.6751 15.3379 18.9836 16.1026 19.4875C16.4702 19.7298 16.7644 19.9301 17.0579 20.13C17.3782 20.3482 17.6977 20.5657 18.1111 20.8367C18.2164 20.9057 18.317 20.9774 18.415 21.0473C18.7879 21.3132 19.123 21.552 19.5368 21.5139C19.7773 21.4918 20.0257 21.2656 20.1519 20.5912Z"
                                          fill="white"/>
                                </svg>
                            </a>
                        </div>
                        <!--                        <div>-->
                        <!--                            <a href="#!" data-toggle="tooltip" data-placement="top" title="Tez kunda" role="button"-->
                        <!--                               class="px-0">-->
                        <!--                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none"-->
                        <!--                                     xmlns="http://www.w3.org/2000/svg">-->
                        <!--                                    <path fill-rule="evenodd" clip-rule="evenodd"-->
                        <!--                                          d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM25.4406 13.264C23.8338 14.2395 23.04 15.5642 23.0495 17.3192C23.0495 17.3217 23.0494 17.3263 23.0492 17.3328C23.0428 17.5646 22.9676 20.2862 26.0001 21.714C25.4167 23.4739 23.4178 27.3857 21.0936 27.4191C20.4425 27.4191 19.9216 27.2182 19.3847 27.011C18.8134 26.7906 18.2239 26.5631 17.4401 26.5631C16.5916 26.5631 15.9529 26.8052 15.3547 27.0321C14.847 27.2245 14.3684 27.406 13.8152 27.4191C11.5102 27.4909 9.30087 23.1869 8.68875 21.4319C8.22966 20.0961 8.00012 18.8017 8.00012 17.5488C8.00012 13.307 10.8359 11.222 13.5044 11.179C14.2442 11.179 15.1001 11.4882 15.8312 11.7524C16.3761 11.9492 16.8516 12.1211 17.1579 12.1211C17.4056 12.1211 17.8098 11.9715 18.3058 11.7881C19.1696 11.4686 20.3117 11.0461 21.3901 11.1311C23.1834 11.2698 24.5416 11.9776 25.4406 13.264ZM21.4916 6.01364C21.5308 6.53191 21.6368 7.93132 20.3428 9.46696C19.4055 10.5621 18.2674 11.2029 17.0192 11.1072C16.914 9.78736 17.4066 8.61574 18.2435 7.66887C19.0038 6.78418 20.3381 6.06685 21.4906 5.9999L21.4916 6.01364Z"-->
                        <!--                                          fill="white"/>-->
                        <!--                                </svg>-->
                        <!--                            </a>-->
                        <!--                        </div>-->
                        <div>
                            <a href="https://play.google.com/store/apps/details?id=org.kadirov.apps.manager&hl=en&gl=US"
                               target="_blank" class="px-0">
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM12.7496 8.45148L20.4019 16.137L22.4858 14.0498L12.7496 8.45148ZM10 9.22593C10 8.6668 10.3017 8.23616 10.7524 8L19.6495 16.8872L10.7524 25.7778C10.3017 25.5416 10 25.111 10 24.5518V9.22593ZM23.4531 14.6506L25.4954 15.8349C26.1611 16.3315 26.1611 17.4498 25.537 17.9464L23.4531 19.1306L21.1751 16.8906L23.4531 14.6506ZM22.4858 19.7315L12.7496 25.3298L20.4019 17.6442L22.4858 19.7315Z"
                                          fill="white"/>
                                </svg>
                            </a>
                        </div>
                        <div>
                            <a href="https://www.youtube.com/@boshqarCom" target="_blank" class="px-0">
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM24.0325 11.3767C24.8069 11.5841 25.4168 12.1953 25.6239 12.9713C26 14.3779 26 17.3126 26 17.3126C26 17.3126 26 20.2472 25.6239 21.6538C25.4168 22.4298 24.8069 23.0155 24.0325 23.2229C22.6287 23.5998 17 23.5998 17 23.5998C17 23.5998 11.3713 23.5998 9.96751 23.2229C9.19307 23.0155 8.58313 22.4298 8.37612 21.6538C7.99999 20.2472 7.99999 17.3126 7.99999 17.3126C7.99999 17.3126 7.99999 14.3779 8.37612 12.9713C8.58313 12.1953 9.19307 11.5841 9.96751 11.3767C11.3713 10.9998 17 10.9998 17 10.9998C17 10.9998 22.6287 10.9998 24.0325 11.3767ZM19.8636 17.3126L15.1591 14.6481V19.977L19.8636 17.3126Z"
                                          fill="white"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="sidenav-shadow" :style="showNavbar === true ? 'width: 100%' : 'width: 0'"
                     @click="showNavbar = false"></div>
            </div>
        </div>
        <!-- /sidenav -->

        <!-- navbar -->
        <div class="container-fluid header">
            <div class="row d-flex justify-content-center">
                <div class="col-12 p-0">
                    <header class="navbar navbar-expand-lg navbar-light bg-white px-lg-4 px-xl-5">
                        <a class="navbar-brand" href="#">
                            <img src="../../public/images/icon/logo.svg"/>
                            <img src="../../public/images/icon/boshqarCom.svg"/>
                        </a>
                        <div class="d-lg-none">
                    <span @click="showNavbar = true">
                        <svg width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M8 9C8 8.44772 8.44772 8 9 8H25C25.5523 8 26 8.44772 26 9C26 9.55228 25.5523 10 25 10H9C8.44772 10 8 9.55228 8 9ZM8 15C8 14.4477 8.44772 14 9 14H25C25.5523 14 26 14.4477 26 15C26 15.5523 25.5523 16 25 16H9C8.44772 16 8 15.5523 8 15ZM9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22H25C25.5523 22 26 21.5523 26 21C26 20.4477 25.5523 20 25 20H9Z"
                                  fill="#8300C5"/>
                            <rect x="0.5" y="0.5" width="33" height="30" rx="4.5" stroke="#8300C5"/>
                            </svg>
                    </span>
                        </div>

                        <div class="collapse navbar-collapse local-bg bg-white " id="navbarSupportedContent">
                            <ul class="navbar-nav mr-auto">
                                <!--                        <li class="nav-item">-->
                                <!--                            <a class="nav-link header-link" href="#">Asosiy sahifa <span-->
                                <!--                                    class="sr-only">(current)</span></a>-->
                                <!--                        </li>-->
                                <li class="nav-item">
                                    <a class="nav-link header-link" style="cursor: pointer"
                                       @click="scrollToBottom('forWhom')">
                                        {{ $t('promoNew.forWhom') }}?
                                    </a>
                                </li>

                                <li class="nav-item">
                                    <a class="nav-link header-link" style="cursor: pointer"
                                       @click="scrollToBottom('price')">
                                        {{ $t('plan.title') }}
                                    </a>
                                </li>
                            </ul>
                            <div class="d-flex align-items-center my-2 my-lg-0">
                                <a href="tel:+998999367070" class="header-link mr-3">
                                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.15312 1.09365C4.9125 0.463729 4.27812 0.12845 3.67188 0.307942L0.921875 1.12074C0.378125 1.2833 0 1.81839 0 2.42799C0 10.8066 6.26875 17.6002 14 17.6002C14.5625 17.6002 15.0563 17.1904 15.2063 16.6012L15.9563 13.6209C16.1219 12.9639 15.8125 12.2764 15.2312 12.0156L12.2312 10.661C11.7219 10.4307 11.1313 10.5898 10.7844 11.0538L9.52188 12.7234C7.32188 11.5957 5.54063 9.66528 4.5 7.28107L6.04063 5.91625C6.46875 5.53694 6.61562 4.90025 6.40312 4.34823L5.15312 1.09703V1.09365Z"
                                            fill="#6F42C1"/>
                                    </svg>
                                    +998 99 936-70-70
                                </a>
                                <PromoLanguageSwitcher class="vr"/>
                                <button
                                    class="btn_borderless my-2 my-sm-0 vr"
                                    type="button"
                                    @click="showModal('login')"
                                >
                                    {{ $t('login.title') }}
                                </button>
                                <button
                                    class="local-button py-1 px-xxl-3 my-2 my-sm-0 ml-xl-4"
                                    type="button"
                                    @click="showModal('signup')"
                                >
                                    {{ $t('company.create') }}
                                </button>
                            </div>
                        </div>
                    </header>
                </div>
            </div>
        </div>
        <!-- /navbar-->

        <!-- intro -->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 p-0 bg-local">
                    <div class="intro px-4 py-5 py-md-3">
                        <div
                            class="d-flex flex-column-reverse flex-lg-row justify-content-sm-center align-items-md-center py-md-5">
                            <div class="d-flex flex-column p-2">
                                <h5 class="intro-title">{{ $t('promoNew.bureaucracy.title') }}</h5>
                                <p class="custom-text">{{ $t('promoNew.bureaucracy.text') }}</p>
                                <ul class="mb-lg-4">
                                    <li class="mb-2 mb-lg-3">
                                        &nbsp;&nbsp;
                                        {{ $t('promoNew.bureaucracy.anywhere') }}
                                    </li>
                                    <li class="mb-2 mb-lg-3">
                                        &nbsp;&nbsp;
                                        {{ $t('promoNew.bureaucracy.anyDevice') }}
                                    </li>
                                    <li class="mb-2 mb-lg-3">
                                        &nbsp;&nbsp;
                                        {{ $t('promoNew.bureaucracy.robbery') }}
                                    </li>
                                    <li class="mb-2 mb-lg-3">
                                        &nbsp;&nbsp;
                                        {{ $t('promoNew.bureaucracy.only') }}
                                        249.000
                                        {{ $t('currencyRate.sum') }}
                                        {{ $t('promoNew.bureaucracy.perMonth') }}
                                    </li>
                                </ul>
                                <div class="d-flex flex-column flex-sm-row align-items-sm-center">
                                    <a href="#signup" @click="showNavbar = false, showModal('signup')"
                                       class="btn local-button mr-5 mb-3 mb-sm-2 bg-local"
                                       style="width: 180px"
                                    >
                                        {{ $t('promoNew.bureaucracy.test') }}
                                    </a>
                                    <a href="https://www.youtube.com/playlist?list=PL18nOJoBIe7B04wnzxNLREiTbjlSBrsPL" class="local-link"
                                       style="width: 180px">
                                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="13" cy="13" r="12.5" fill="#F4F4F3" stroke="#8300C5"/>
                                            <path
                                                d="M17.9621 12.4684C18.2954 12.6609 18.2954 13.142 17.9621 13.3344L10.7462 17.5005C10.4129 17.693 9.99619 17.4524 9.99619 17.0675V8.73532C9.99619 8.35042 10.4129 8.10986 10.7462 8.30231L17.9621 12.4684Z"
                                                fill="#8300C5"/>
                                        </svg>
                                        {{ $t('promoNew.bureaucracy.howItWorks') }}
                                    </a>
                                </div>
                            </div>
                            <div class="p-sm-3 p-md-5 p-lg-2">
                                <img src="../../public/images/image-47.png" class="card-img mw-100" alt="macbook">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /intro -->

        <!--business cards -->
        <div class="container-fluid pt-5" ref="forWhom">
            <div class="row">
                <div class="col">
                    <div class="row business px-md-4 pt-lg-4 pt-xl-5 mx-auto width-90">
                        <h5 class="col-12 custom-title text-md-center">{{ $t('promoNew.forAllBusiness.title') }}</h5>
                        <p class="col-12 col-md-10 col-lg-8 col-xl-6 business-card__text text-md-center mx-auto">
                            {{ $t('promoNew.forAllBusiness.text') }}
                        </p>
                        <div class="col-12">
                            <div class="row d-flex justify-content-center business-card py-lg-3">
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="34" height="28" viewBox="0 0 34 28" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1.955 10.3085H32.045C33.1234 10.3085 34 9.42262 34 8.33271C34 7.94077 33.8831 7.55957 33.6706 7.23743L29.6544 1.14897C29.1816 0.429521 28.39 0 27.5347 0H6.46531C5.61531 0 4.81844 0.429521 4.34563 1.14897L0.329375 7.23206C0.116875 7.55957 0 7.94077 0 8.32734C0 9.42262 0.876563 10.3085 1.955 10.3085ZM3.4 12.0266V20.617V24.9122C3.4 26.335 4.54219 27.4894 5.95 27.4894H17.85C19.2578 27.4894 20.4 26.335 20.4 24.9122V20.617V12.0266H17V20.617H6.8V12.0266H3.4ZM27.2 12.0266V25.7713C27.2 26.7216 27.9597 27.4894 28.9 27.4894C29.8403 27.4894 30.6 26.7216 30.6 25.7713V12.0266H27.2Z"
                                                fill="#A0A0A0"/>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.supermarket') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="34" height="27" viewBox="0 0 34 27" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6.61111 3.77778C5.04687 3.77778 3.77778 5.04687 3.77778 6.61111V13.2222H9.44444V6.61111C9.44444 5.04687 8.17535 3.77778 6.61111 3.77778ZM0 6.61111C0 2.95729 2.95729 0 6.61111 0C10.2649 0 13.2222 2.95729 13.2222 6.61111V19.8333C13.2222 23.4872 10.2649 26.4444 6.61111 26.4444C2.95729 26.4444 0 23.4872 0 19.8333V6.61111ZM32.7545 21.6868C32.3354 22.4128 31.3556 22.4601 30.7594 21.8698L19.6858 10.7962C19.0955 10.2059 19.1368 9.22014 19.8687 8.80104C21.25 8.01007 22.8497 7.55555 24.5556 7.55555C29.7736 7.55555 34 11.7819 34 17C34 18.7059 33.5455 20.3056 32.7545 21.6868ZM29.2424 25.199C27.8611 25.9899 26.2615 26.4444 24.5556 26.4444C19.3375 26.4444 15.1111 22.2181 15.1111 17C15.1111 15.2941 15.5656 13.6944 16.3566 12.3132C16.7757 11.5872 17.7556 11.5399 18.3517 12.1302L29.4253 23.2038C30.0156 23.7941 29.9743 24.7799 29.2424 25.199Z"
                                                fill="#A0A0A0"/>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.pharmacy') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6.375 2.125V8.5H14.875V2.125C14.875 0.949609 13.9254 0 12.75 0H8.5C7.32461 0 6.375 0.949609 6.375 2.125ZM6.375 10.625C2.85547 10.625 0 13.4805 0 17V30.8125C0 32.5723 1.42773 34 3.1875 34H18.0625C19.8223 34 21.25 32.5723 21.25 30.8125V17C21.25 13.4805 18.3945 10.625 14.875 10.625H6.375ZM10.625 27.625C7.68984 27.625 5.3125 25.2477 5.3125 22.3125C5.3125 19.3773 7.68984 17 10.625 17C13.5602 17 15.9375 19.3773 15.9375 22.3125C15.9375 25.2477 13.5602 27.625 10.625 27.625ZM25.5 3.1875C25.5 3.09453 25.4336 2.98828 25.3539 2.94844L23.375 2.125L22.5516 0.146094C22.5117 0.0664062 22.4055 0 22.3125 0C22.2195 0 22.1133 0.0664062 22.0734 0.146094L21.25 2.125L19.2711 2.94844C19.1914 2.98828 19.125 3.09453 19.125 3.1875C19.125 3.28047 19.1914 3.38672 19.2711 3.42656L21.25 4.25L22.0734 6.22891C22.1133 6.30859 22.2195 6.375 22.3125 6.375C22.4055 6.375 22.5117 6.30859 22.5516 6.22891L23.375 4.25L25.3539 3.42656C25.4336 3.38672 25.5 3.28047 25.5 3.1875ZM30.5734 6.22891C30.6133 6.30859 30.7195 6.375 30.8125 6.375C30.9055 6.375 31.0117 6.30859 31.0516 6.22891L31.875 4.25L33.8539 3.42656C33.9336 3.38672 34 3.28047 34 3.1875C34 3.09453 33.9336 2.98828 33.8539 2.94844L31.875 2.125L31.0516 0.146094C31.0117 0.0664062 30.9055 0 30.8125 0C30.7195 0 30.6133 0.0664062 30.5734 0.146094L29.75 2.125L27.7711 2.94844C27.6914 2.98828 27.625 3.09453 27.625 3.1875C27.625 3.28047 27.6914 3.38672 27.7711 3.42656L29.75 4.25L30.5734 6.22891ZM31.0516 12.8961C31.0117 12.8164 30.9055 12.75 30.8125 12.75C30.7195 12.75 30.6133 12.8164 30.5734 12.8961L29.75 14.875L27.7711 15.6984C27.6914 15.7383 27.625 15.8445 27.625 15.9375C27.625 16.0305 27.6914 16.1367 27.7711 16.1766L29.75 17L30.5734 18.9789C30.6133 19.0586 30.7195 19.125 30.8125 19.125C30.9055 19.125 31.0117 19.0586 31.0516 18.9789L31.875 17L33.8539 16.1766C33.9336 16.1367 34 16.0305 34 15.9375C34 15.8445 33.9336 15.7383 33.8539 15.6984L31.875 14.875L31.0516 12.8961ZM29.75 9.5625C29.75 9.46953 29.6836 9.36328 29.6039 9.32344L27.625 8.5L26.8016 6.52109C26.7617 6.44141 26.6555 6.375 26.5625 6.375C26.4695 6.375 26.3633 6.44141 26.3234 6.52109L25.5 8.5L23.5211 9.32344C23.4414 9.36328 23.375 9.46953 23.375 9.5625C23.375 9.65547 23.4414 9.76172 23.5211 9.80156L25.5 10.625L26.3234 12.6039C26.3633 12.6836 26.4695 12.75 26.5625 12.75C26.6555 12.75 26.7617 12.6836 26.8016 12.6039L27.625 10.625L29.6039 9.80156C29.6836 9.76172 29.75 9.65547 29.75 9.5625Z"
                                                fill="#A0A0A0"/>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.perfumery') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M23.375 21.25C29.2453 21.25 34 16.4953 34 10.625C34 9.60898 33.8539 8.62617 33.5883 7.68984C33.3824 6.97266 32.4992 6.81328 31.9746 7.33789L26.8746 12.4379C26.6754 12.6371 26.4031 12.75 26.1242 12.75H22.3125C21.7281 12.75 21.25 12.2719 21.25 11.6875V7.87578C21.25 7.59687 21.3629 7.32461 21.5621 7.12539L26.6621 2.02539C27.1867 1.50078 27.0207 0.617578 26.3102 0.411719C25.3738 0.146094 24.391 0 23.375 0C17.5047 0 12.75 4.75469 12.75 10.625C12.75 11.8934 12.9758 13.1152 13.3809 14.2441L1.32148 26.3035C0.478125 27.1469 0 28.2957 0 29.491C0 31.9813 2.01875 34 4.50898 34C5.7043 34 6.85313 33.5219 7.69648 32.6785L19.7559 20.6191C20.8848 21.0309 22.1066 21.25 23.375 21.25ZM5.3125 30.2812C4.4293 30.2812 3.71875 29.5707 3.71875 28.6875C3.71875 27.8043 4.4293 27.0938 5.3125 27.0938C6.1957 27.0938 6.90625 27.8043 6.90625 28.6875C6.90625 29.5707 6.1957 30.2812 5.3125 30.2812Z"
                                                fill="#A0A0A0"/>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.plumbing') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="34" height="31" viewBox="0 0 34 31" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M32.3236 6.12708L28.9413 0.773264C28.6403 0.295139 28.1031 0 27.5305 0H6.46943C5.89686 0 5.35971 0.295139 5.05867 0.773264L1.67047 6.12708C-0.076748 8.88958 1.46978 12.7323 4.73402 13.175C4.97013 13.2045 5.21214 13.2222 5.44825 13.2222C6.98888 13.2222 8.35832 12.5493 9.29686 11.5104C10.2354 12.5493 11.6048 13.2222 13.1455 13.2222C14.6861 13.2222 16.0555 12.5493 16.9941 11.5104C17.9326 12.5493 19.3021 13.2222 20.8427 13.2222C22.3892 13.2222 23.7528 12.5493 24.6913 11.5104C25.6358 12.5493 26.9993 13.2222 28.5399 13.2222C28.7819 13.2222 29.018 13.2045 29.2542 13.175C32.5302 12.7382 34.0826 8.89549 32.3295 6.12708H32.3236ZM29.4962 15.0462H29.4903C29.1774 15.0875 28.8587 15.1111 28.534 15.1111C27.8021 15.1111 27.0996 14.999 26.4444 14.7983V22.6667H7.55554V14.7924C6.89443 14.999 6.1861 15.1111 5.45415 15.1111C5.1295 15.1111 4.80485 15.0875 4.492 15.0462H4.4861C4.24409 15.0108 4.00797 14.9694 3.77777 14.9104V22.6667V26.4444C3.77777 28.5281 5.47186 30.2222 7.55554 30.2222H26.4444C28.5281 30.2222 30.2222 28.5281 30.2222 26.4444V22.6667V14.9104C29.9861 14.9694 29.75 15.0167 29.4962 15.0462Z"
                                                fill="#A0A0A0"/>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.foodStore') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="34" height="28" viewBox="0 0 34 28" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M11.2519 0C11.6662 0 12.0116 0.302812 12.1391 0.70125C12.7925 2.75719 14.7209 4.25 17 4.25C19.2791 4.25 21.2075 2.75719 21.8609 0.70125C21.9884 0.302812 22.3337 0 22.7481 0H23.4175C24.6128 0 25.7656 0.419687 26.6847 1.18469L33.3891 6.76813C33.7397 7.06031 33.9575 7.48531 33.9947 7.94219C34.0319 8.39906 33.8831 8.85063 33.5803 9.19594L30.6053 12.5959C29.9997 13.2919 28.9478 13.3716 28.2359 12.7819L25.5 10.5028V23.8C25.5 25.6753 23.9753 27.2 22.1 27.2H11.9C10.0247 27.2 8.49999 25.6753 8.49999 23.8V10.5028L5.76405 12.7819C5.05749 13.3716 4.00562 13.2919 3.39468 12.5959L0.41968 9.19594C0.116868 8.85063 -0.0318823 8.39906 0.00530524 7.94219C0.0424927 7.48531 0.260305 7.06031 0.61093 6.76813L7.31531 1.18469C8.23437 0.419687 9.38718 0 10.5825 0H11.2519Z"
                                                fill="#A0A0A0"/>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.clothingStore') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="34" height="28" viewBox="0 0 34 28" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M15.1111 0.888672C14.0663 0.888672 13.2222 1.73277 13.2222 2.77756V2.91332V8.79249C13.2222 9.12305 12.9566 9.38867 12.626 9.38867C12.4135 9.38867 12.2128 9.27652 12.1066 9.08763L9.27326 4.1352C4.89931 6.28971 1.88889 10.7935 1.88889 15.9998V19.7776H32.1111V15.8581C32.058 10.7109 29.0594 6.272 24.7267 4.1352L21.8934 9.08763C21.7872 9.27652 21.5865 9.38867 21.374 9.38867C21.0434 9.38867 20.7778 9.12305 20.7778 8.79249V2.91332V2.77756C20.7778 1.73277 19.9337 0.888672 18.8889 0.888672H15.1111ZM0.979861 21.6664C0.436806 21.6664 0 22.1033 0 22.6463C0 22.9237 0.118056 23.1894 0.342361 23.3487C1.62326 24.2873 6.59931 27.3331 17 27.3331C27.4007 27.3331 32.3767 24.2873 33.6576 23.3487C33.8819 23.1835 34 22.9237 34 22.6463C34 22.1033 33.5632 21.6664 33.0201 21.6664H0.979861Z"
                                                fill="#A0A0A0"/>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.constructionStore') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                                    <div
                                        class="business-card__item d-flex align-items-center justify-content-md-center px-3 px-sm-5 px-md-2 rounded">
                                        <svg width="29" height="34" viewBox="0 0 29 34" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.401747 31.1111C0.232031 31.3428 0.0623144 31.5331 0.0283711 31.5331C3.50215 19.5317 9.33825 18.9413 14.8207 18.3866C17.8647 18.0786 20.7997 17.7817 23.1607 15.5487C24.5732 17.1482 26.0584 21.0969 20.6998 24.0952L20.4792 23.9049C20.3604 23.7974 19.4948 23.1934 18.5699 22.5563C17.6449 21.9193 16.3127 21.0009 15.6083 20.5128C14.9125 20.0246 14.31 19.6192 14.2761 19.6192C14.2336 19.6192 14.2082 20.2811 14.2082 21.0919V22.5646L13.2153 22.8707C10.9072 23.5822 8.12384 24.8398 6.34182 25.9567C3.97428 27.446 1.70856 29.4151 0.401747 31.1111Z"
                                                fill="white"/>
                                            <path
                                                d="M4.53434 10.6839V5.84388V0.995617L12.1122 1.02044C19.6306 1.04526 19.69 1.05353 20.3604 1.23555C21.6682 2.26698 25.4575 4.64423 20.7338 9.09537L19.7834 8.42521C19.2572 8.06118 18.3408 7.42412 17.7298 7.00217C17.1273 6.58022 16.109 5.88525 15.4811 5.44675C14.8531 5.00826 14.31 4.64423 14.2761 4.64423C14.2336 4.64423 14.2082 5.29783 14.2082 6.09209C14.2082 6.88634 14.1827 7.53995 14.1403 7.53995C13.9197 7.53995 11.5606 7.97845 11.009 8.12737C8.70937 8.73133 6.60488 9.52559 5.06895 10.386L4.53434 10.6839Z"
                                                fill="white"/>
                                            <path
                                                d="M20.5471 9.26084L20.7338 9.09537C25.4575 4.64423 21.6682 2.26698 20.3604 1.23555C21.7351 1.59958 23.585 2.71651 24.4421 3.70105C25.8507 5.30611 26.5466 7.06009 26.5381 8.98781C26.5381 10.0303 26.4447 10.6177 26.1562 11.5112C25.7149 12.8681 24.5948 14.4566 23.5001 15.2922L23.1607 15.5487C20.7997 17.7817 17.8647 18.0786 14.8207 18.3866C9.33825 18.9413 3.50215 19.5317 0.0283711 31.5331C-0.064973 31.5331 0.0877718 29.2 0.257488 28.1409C0.987269 23.5161 3.06629 19.3545 6.22302 16.194C7.21586 15.2095 8.78574 13.9602 10.152 13.0749C10.9327 12.5785 13.8687 11.0976 14.0809 11.0976C14.1912 11.0976 14.2082 11.2961 14.2082 12.3386C14.2082 13.017 14.2251 13.5796 14.2506 13.5796C14.3015 13.5796 15.8035 12.5702 17.3055 11.5112C17.8656 11.1224 18.782 10.4936 19.3421 10.113C19.9022 9.73243 20.4453 9.34357 20.5471 9.26084Z"
                                                fill="white"/>
                                            <path
                                                d="M20.4877 24.2524L20.6998 24.0952C26.0584 21.0969 24.5732 17.1482 23.1607 15.5487L23.4492 15.7059C25.1464 16.616 25.9526 17.2034 26.7672 18.1466C28.4219 20.0577 29.1772 22.3826 28.965 24.9556C28.8292 26.569 28.3116 27.9507 27.3357 29.3241C26.1817 30.9374 24.51 32.1701 22.6091 32.7989C21.2429 33.254 20.9714 33.2705 14.3609 33.2705C11.009 33.2705 8.2681 33.254 8.2681 33.2291C8.2681 33.0637 8.84514 31.4752 9.0488 31.078C9.66826 29.8784 10.9411 28.2402 11.8915 27.4294C12.7401 26.7096 13.9366 25.9071 14.1657 25.9071C14.1912 25.9071 14.2082 26.5028 14.2082 27.2309C14.2082 27.9589 14.2251 28.5546 14.2421 28.5546C14.2845 28.5546 20.0804 24.5585 20.4877 24.2524Z"
                                                fill="white"/>
                                            <path
                                                d="M0.401747 31.1111C0.232031 31.3428 0.0623144 31.5331 0.0283711 31.5331C3.50215 19.5317 9.33825 18.9413 14.8207 18.3866C17.8647 18.0786 20.7997 17.7817 23.1607 15.5487C24.5732 17.1482 26.0584 21.0969 20.6998 24.0952L20.4792 23.9049C20.3604 23.7974 19.4948 23.1934 18.5699 22.5563C17.6449 21.9193 16.3127 21.0009 15.6083 20.5128C14.9125 20.0246 14.31 19.6192 14.2761 19.6192C14.2336 19.6192 14.2082 20.2811 14.2082 21.0919V22.5646L13.2153 22.8707C10.9072 23.5822 8.12384 24.8398 6.34182 25.9567C3.97428 27.446 1.70856 29.4151 0.401747 31.1111Z"
                                                fill="url(#paint0_linear_219_2630)"/>
                                            <path
                                                d="M4.53434 10.6839V5.84388V0.995617L12.1122 1.02044C19.6306 1.04526 19.69 1.05353 20.3604 1.23555C21.6682 2.26698 25.4575 4.64423 20.7338 9.09537L19.7834 8.42521C19.2572 8.06118 18.3408 7.42412 17.7298 7.00217C17.1273 6.58022 16.109 5.88525 15.4811 5.44675C14.8531 5.00826 14.31 4.64423 14.2761 4.64423C14.2336 4.64423 14.2082 5.29783 14.2082 6.09209C14.2082 6.88634 14.1827 7.53995 14.1403 7.53995C13.9197 7.53995 11.5606 7.97845 11.009 8.12737C8.70937 8.73133 6.60488 9.52559 5.06895 10.386L4.53434 10.6839Z"
                                                fill="url(#paint1_linear_219_2630)"/>
                                            <path
                                                d="M20.5471 9.26084L20.7338 9.09537C25.4575 4.64423 21.6682 2.26698 20.3604 1.23555C21.7351 1.59958 23.585 2.71651 24.4421 3.70105C25.8507 5.30611 26.5466 7.06009 26.5381 8.98781C26.5381 10.0303 26.4447 10.6177 26.1562 11.5112C25.7149 12.8681 24.5948 14.4566 23.5001 15.2922L23.1607 15.5487C20.7997 17.7817 17.8647 18.0786 14.8207 18.3866C9.33825 18.9413 3.50215 19.5317 0.0283711 31.5331C-0.064973 31.5331 0.0877718 29.2 0.257488 28.1409C0.987269 23.5161 3.06629 19.3545 6.22302 16.194C7.21586 15.2095 8.78574 13.9602 10.152 13.0749C10.9327 12.5785 13.8687 11.0976 14.0809 11.0976C14.1912 11.0976 14.2082 11.2961 14.2082 12.3386C14.2082 13.017 14.2251 13.5796 14.2506 13.5796C14.3015 13.5796 15.8035 12.5702 17.3055 11.5112C17.8656 11.1224 18.782 10.4936 19.3421 10.113C19.9022 9.73243 20.4453 9.34357 20.5471 9.26084Z"
                                                fill="#A0A0A0"/>
                                            <path
                                                d="M20.4877 24.2524L20.6998 24.0952C26.0584 21.0969 24.5732 17.1482 23.1607 15.5487L23.4492 15.7059C25.1464 16.616 25.9526 17.2034 26.7672 18.1466C28.4219 20.0577 29.1772 22.3826 28.965 24.9556C28.8292 26.569 28.3116 27.9507 27.3357 29.3241C26.1817 30.9374 24.51 32.1701 22.6091 32.7989C21.2429 33.254 20.9714 33.2705 14.3609 33.2705C11.009 33.2705 8.2681 33.254 8.2681 33.2291C8.2681 33.0637 8.84514 31.4752 9.0488 31.078C9.66826 29.8784 10.9411 28.2402 11.8915 27.4294C12.7401 26.7096 13.9366 25.9071 14.1657 25.9071C14.1912 25.9071 14.2082 26.5028 14.2082 27.2309C14.2082 27.9589 14.2251 28.5546 14.2421 28.5546C14.2845 28.5546 20.0804 24.5585 20.4877 24.2524Z"
                                                fill="#A0A0A0"/>
                                            <path
                                                d="M20.5471 9.26084L20.7338 9.09537C25.4575 4.64423 21.6682 2.26698 20.3604 1.23555C21.7351 1.59958 23.585 2.71651 24.4421 3.70105C25.8507 5.30611 26.5466 7.06009 26.5381 8.98781C26.5381 10.0303 26.4447 10.6177 26.1562 11.5112C25.7149 12.8681 24.5948 14.4566 23.5001 15.2922L23.1607 15.5487C20.7997 17.7817 17.8647 18.0786 14.8207 18.3866C9.33825 18.9413 3.50215 19.5317 0.0283711 31.5331C-0.064973 31.5331 0.0877718 29.2 0.257488 28.1409C0.987269 23.5161 3.06629 19.3545 6.22302 16.194C7.21586 15.2095 8.78574 13.9602 10.152 13.0749C10.9327 12.5785 13.8687 11.0976 14.0809 11.0976C14.1912 11.0976 14.2082 11.2961 14.2082 12.3386C14.2082 13.017 14.2251 13.5796 14.2506 13.5796C14.3015 13.5796 15.8035 12.5702 17.3055 11.5112C17.8656 11.1224 18.782 10.4936 19.3421 10.113C19.9022 9.73243 20.4453 9.34357 20.5471 9.26084Z"
                                                fill="#A0A0A0"/>
                                            <path
                                                d="M0.401747 31.1111C0.232031 31.3428 0.0623144 31.5331 0.0283711 31.5331C3.50215 19.5317 9.33825 18.9413 14.8207 18.3866C17.8647 18.0786 20.7997 17.7817 23.1607 15.5487C24.5732 17.1482 26.0584 21.0969 20.6998 24.0952L20.4792 23.9049C20.3604 23.7974 19.4948 23.1934 18.5699 22.5563C17.6449 21.9193 16.3127 21.0009 15.6083 20.5128C14.9125 20.0246 14.31 19.6192 14.2761 19.6192C14.2336 19.6192 14.2082 20.2811 14.2082 21.0919V22.5646L13.2153 22.8707C10.9072 23.5822 8.12384 24.8398 6.34182 25.9567C3.97428 27.446 1.70856 29.4151 0.401747 31.1111Z"
                                                fill="#A0A0A0"/>
                                            <path
                                                d="M4.53434 10.6839V5.84388V0.995617L12.1122 1.02044C19.6306 1.04526 19.69 1.05353 20.3604 1.23555C21.6682 2.26698 25.4575 4.64423 20.7338 9.09537L19.7834 8.42521C19.2572 8.06118 18.3408 7.42412 17.7298 7.00217C17.1273 6.58022 16.109 5.88525 15.4811 5.44675C14.8531 5.00826 14.31 4.64423 14.2761 4.64423C14.2336 4.64423 14.2082 5.29783 14.2082 6.09209C14.2082 6.88634 14.1827 7.53995 14.1403 7.53995C13.9197 7.53995 11.5606 7.97845 11.009 8.12737C8.70937 8.73133 6.60488 9.52559 5.06895 10.386L4.53434 10.6839Z"
                                                fill="#A0A0A0"/>
                                            <defs>
                                                <linearGradient id="paint0_linear_219_2630" x1="20.2811" y1="33.2622"
                                                                x2="20.1198"
                                                                y2="15.3914"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#5200B4"/>
                                                    <stop offset="1" stop-color="#DC83E7"/>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_219_2630" x1="20.2811" y1="33.2622"
                                                                x2="20.1198"
                                                                y2="15.3914"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#5200B4"/>
                                                    <stop offset="1" stop-color="#DC83E7"/>
                                                </linearGradient>
                                                <linearGradient id="paint2_linear_219_2630" x1="20.2811" y1="33.2622"
                                                                x2="20.1198"
                                                                y2="15.3914"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#5200B4"/>
                                                    <stop offset="1" stop-color="#DC83E7"/>
                                                </linearGradient>
                                                <linearGradient id="paint3_linear_219_2630" x1="20.2811" y1="33.2622"
                                                                x2="20.1198"
                                                                y2="15.3914"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#5200B4"/>
                                                    <stop offset="1" stop-color="#DC83E7"/>
                                                </linearGradient>
                                                <linearGradient id="paint4_linear_219_2630" x1="20.4933" y1="30.7388"
                                                                x2="20.5336"
                                                                y2="0.995614"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#5200B4"/>
                                                    <stop offset="0.703966" stop-color="#DC83E7"/>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <span class="ml-3">{{ $t('promoNew.forAllBusiness.variousBusiness') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/business cards-->

        <!-- Opportunities -->
        <div class="container-fluid px-md-5">
            <div class="row">
                <div class="col">
                    <!--  trade  -->
                    <div class="bg-white component py-3 py-md-5 width-90 mx-auto">
                        <div class="row align-items-center flex-column-reverse flex-md-row justify-content-md-between">
                            <div class="col-12 col-md-6 d-flex flex-column">
                                <p class="component-name text-uppercase py-lg-3">{{ $t('promoNew.sale.sale') }}</p>
                                <h5 class="custom-title">{{ $t('promoNew.sale.title') }}</h5>
                                <ul class="custom-text">
                                    <li>{{ $t('promoNew.sale.text.sellProduct') }}</li>
                                    <li>{{ $t('promoNew.sale.text.accountOnDept') }}</li>
                                    <li>{{ $t('promoNew.sale.text.saleStatistics') }}</li>
                                </ul>
                            </div>
                            <div
                                class="col-12 col-md-6 col-lg-5 d-flex justify-content-center overflow-hidden mb-4 p-0 p-md-3">
                                <img src="../../public/images/savdo.png" class="component-img" alt="trade">
                            </div>
                        </div>
                    </div>
                    <!--  /trade  -->

                    <!-- products -->
                    <div class="bg-white component py-3 py-md-5 width-90 mx-auto">
                        <div class="row justify-content-around align-items-center">
                            <div
                                class="col-12 col-md-6 col-lg-5 d-flex justify-content-center overflow-hidden mb-4 p-0 p-md-3">
                                <img src="../../public/images/mahsulotlar.png" class="component-img" alt="products">
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-center">
                                <p class="component-name text-uppercase">{{ $t('promoNew.product.product') }}</p>
                                <h5 class="custom-title">
                                    {{ $t('promoNew.product.title') }}
                                </h5>
                                <p class="custom-text">{{ $t('promoNew.product.text') }}</p>
                                <div class="product-tabs">
                                    <ul class="nav nav-tabs d-flex justify-content-between justify-content-xl-start sticky-top bg-white mb-3"
                                        id="myTab" role="tablist"
                                        style="list-style-type: none !important;"
                                    >
                                        <li class="nav-item">
                                            <button
                                                class="active"
                                                id="analytics-tab"
                                                data-toggle="tab"
                                                data-target="#analytics"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                {{ $t('promoNew.product.analytics.analytics') }}
                                            </button>
                                        </li>
                                        <li class="nav-item">
                                            <button
                                                class=""
                                                id="store-tab"
                                                data-toggle="tab"
                                                data-target="#store"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="true"
                                            >
                                                {{ $t('warehouse.title') }}
                                            </button>
                                        </li>
                                        <li class="nav-item">
                                            <button
                                                class=""
                                                id="finance-tab"
                                                data-toggle="tab"
                                                data-target="#finance"
                                                type="button"
                                                role="tab"
                                                aria-controls="contact"
                                                aria-selected="false"
                                            >
                                                {{ $t('promoNew.product.finance.finance') }}
                                            </button>
                                        </li>
                                        <li class="nav-item" style="list-style-type: none !important;">
                                            <button
                                                class=""
                                                id="marketing-tab"
                                                data-toggle="tab"
                                                data-target="#marketing"
                                                type="button"
                                                role="tab"
                                                aria-controls="contact"
                                                aria-selected="false"
                                            >
                                                {{ $t('promoNew.product.marketing.marketing') }}
                                            </button>
                                        </li>
                                    </ul>
                                    <div class="tab-content" id="myTabContent">
                                        <div
                                            class="tab-pane fade show active"
                                            id="analytics"
                                            role="tabpanel"
                                            aria-labelledby="store-tab"
                                        >
                                            {{ $t('promoNew.product.analytics.analyticsText') }}
                                        </div>
                                        <div
                                            class="tab-pane fade"
                                            id="store"
                                            role="tabpanel"
                                            aria-labelledby="store-tab"
                                        >
                                            {{ $t('promoNew.product.storeText') }}
                                        </div>
                                        <div
                                            class="tab-pane fade"
                                            id="finance"
                                            role="tabpanel"
                                            aria-labelledby="finance-tab"
                                        >
                                            {{ $t('promoNew.product.finance.financeText') }}
                                        </div>
                                        <div
                                            class="tab-pane fade"
                                            id="marketing"
                                            role="tabpanel"
                                            aria-labelledby="marketing-tab">
                                            {{ $t('promoNew.product.marketing.marketingText') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /products -->

                    <!--  supervision  -->
                    <div class="bg-white component py-3 py-md-5 width-90 mx-auto">
                        <div class="row align-items-center flex-column-reverse flex-md-row justify-content-md-between">
                            <div class="col-12 col-md-6 col-lg-6 d-flex flex-column">
                                <p class="component-name text-uppercase py-lg-3">
                                    {{ $t('promoNew.observe.observe') }}
                                </p>
                                <h5 class="custom-title">
                                    {{ $t('promoNew.observe.title') }}
                                </h5>
                                <p class="custom-text">
                                    {{ $t('promoNew.observe.text') }}
                                </p>
                                <ul>
                                    <li class="mb-3">&nbsp;&nbsp;{{ $t('promoNew.observe.checkCalculation') }}</li>
                                    <li class="mb-3"> &nbsp;{{ $t('promoNew.observe.checkRemainder') }}</li>
                                    <li class="mb-3">&nbsp;&nbsp;{{ $t('promoNew.observe.addTransaction') }}</li>
                                </ul>
                            </div>
                            <div
                                class="col-12 col-md-6 col-lg-5 d-flex justify-content-center overflow-hidden mb-4 p-0 p-md-3">
                                <img src="../../public/images/kuzatuv.png" class="component-img" alt="supervisor">
                            </div>
                        </div>
                    </div>
                    <!--  /supervision  -->

                    <!--  Customer -->
                    <div class="bg-white component py-3 py-md-5 width-90 mx-auto">
                        <div class="row justify-content-around align-items-center">
                            <div
                                class="col-12 col-md-6 col-lg-5 d-flex justify-content-center overflow-hidden mb-4 p-0 p-md-3">
                                <img src="../../public/images/mijoz.png" class="component-img" alt="client">
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-center">
                                <p class="component-name text-uppercase py-lg-3">
                                    {{ $t('promoNew.customer.customer') }}
                                </p>
                                <h5 class="custom-title">
                                    {{ $t('promoNew.customer.title') }}
                                </h5>
                                <p class="custom-text">
                                    {{ $t('promoNew.customer.text') }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--  /Customer  -->

                    <!--  Transactions  -->
                    <div class="bg-white component py-3 py-md-5 width-90 mx-auto">
                        <div class="row justify-content-between align-items-center flex-column-reverse flex-md-row">
                            <div class="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-end">
                                <p class="component-name text-uppercase py-lg-3">
                                    {{ $t('promoNew.transaction.transactions') }}
                                </p>
                                <h5 class="custom-title">
                                    {{ $t('promoNew.transaction.title') }}
                                </h5>
                                <p class="custom-text">
                                    {{ $t('promoNew.transaction.text') }}
                                </p>
                            </div>
                            <div
                                class="col-12 col-md-6 col-lg-5 d-flex justify-content-center overflow-hidden mb-4 p-0 p-md-3">
                                <img src="../../public/images/transaction.png" class="component-img" alt="transactions">
                            </div>
                        </div>
                    </div>
                    <!--  /Transactions -->

                    <!--  Workers -->
                    <div class="bg-white component py-3 py-md-5 width-90 mx-auto">
                        <div class="row justify-content-around align-items-center">
                            <div
                                class="col-12 col-md-6 col-lg-5 d-flex justify-content-center overflow-hidden mb-4 p-0 p-md-3">
                                <img src="../../public/images/workers.png" class="component-img" alt="workers">
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-end">
                                <p class="component-name text-uppercase py-lg-3">
                                    {{ $t('promoNew.employee.employees') }}
                                </p>
                                <h5 class="custom-title">
                                    {{ $t('promoNew.employee.title') }}
                                </h5>
                                <p class="custom-text">
                                    {{ $t('promoNew.employee.text') }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--  /Workers  -->

                    <!--  Secutiry  -->
                    <div class="bg-white component py-3 py-md-5 width-90 mx-auto">
                        <div class="row justify-content-between align-items-center flex-column-reverse flex-md-row">
                            <div class="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-end">
                                <p class="component-name text-uppercase py-lg-3">
                                    {{ $t('promoNew.security.security') }}
                                </p>
                                <h5 class="custom-title">
                                    {{ $t('promoNew.security.title') }}
                                </h5>
                                <p class="custom-text">
                                    {{ $t('promoNew.security.text') }}
                                </p>
                            </div>
                            <div
                                class="col-12 col-md-6 col-lg-5 d-flex justify-content-center overflow-hidden mb-4 p-0 p-md-3">
                                <img src="../../public/images/security.png" class="component-img" alt="security">
                            </div>
                        </div>
                    </div>
                    <!--  /Security -->

                </div>
            </div>
        </div>
        <!-- /Opportunities -->

        <!--  Price  -->
        <div class="container-fluid pt-5" ref="price">
            <div class="row">
                <div class="col px-0 px-md-2">
                    <!-- Price header-->
                    <div class="row price-header bg-local width-90 mx-auto py-4 mb-3">

                        <!-- Price title and text-->
                        <div class="col-12">
                            <h5 class="plans-title text-center pt-3 pb-2">
                                {{ $t('plan.title') }}
                            </h5>
                            <p class="plans-text text-center pb-5">
                                {{ $t('plan.mainTitle') }}
                                <br>
                                {{ $t('plan.subTitle') }}
                            </p>
                        </div>
                        <!-- /Price title and text-->

                        <div class="col-12 px-0">
                            <div class="row mw-100">
                                <!-- month/year toggle-->
                                <div
                                    class="col-md-4 justify-content-center justify-content-md-start d-flex align-items-md-end">
                                    <div class="payment-method d-flex flex-column flex-xl-row align-items-center ml-3">
                                        <p class="payment-term">{{ $t('promoNew.tariff.paymentTerm') }}</p>
                                        <div class="d-flex justify-content-center">
                                            <label class="payment-method__name d-flex align-items-center"
                                                   @click="isMonth = false">
                                                <input type="radio" checked="checked" name="radio" value="mothly"
                                                       id="mothly">
                                                <div class="checkmark">{{ $t('statistics.type.statByMonth') }}</div>
                                            </label>
                                            <label class="payment-method__name d-flex align-items-center"
                                                   @click="isMonth = true">
                                                <input type="radio" name="radio" value="yearly" id="yearly">
                                                <div class="checkmark yearly">{{
                                                        $t('statistics.type.statByYear')
                                                    }}
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <!-- /month/year toggle-->

                                <!-- Lite, Standard, Premium only seen medium and large-->
                                <div class="col-xl-8 d-none d-md-block px-0">
                                    <div class="row">
                                        <div class="col-4 d-flex flex-column justify-content-center px-0">
                                            <p class="plans-name rounded lite mx-auto">Lite</p>
                                            <p class="plans-type">{{ $t('promoNew.tariff.smallBusiness') }}</p>
                                            <div class="d-flex align-items-center justify-content-center">
                                                <div class="d-flex flex-column d-lg-block" v-if="isMonth === false">
                                                    <span class="plans-price">249.000</span>
                                                    <span class="plans-price__text text-uppercase">
                                                         {{ $t('currencyRate.sum') }}
                                                         {{ $t('promoNew.bureaucracy.perMonth') }}
                                                    </span>
                                                </div>
                                                <div class="d-flex flex-column d-lg-block" v-else>
                                                    <span
                                                        class="plans-price"
                                                    >
                                                        2 490.000
                                                    </span>
                                                    <span class="plans-price__text text-uppercase">
                                                        {{ $t('currencyRate.sum') }} / {{ $t('year') }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 d-flex flex-column justify-content-center px-0">
                                            <p class="plans-name rounded standard mx-auto">Standart</p>
                                            <p class="plans-type">{{ $t('promoNew.tariff.middleBusiness') }}</p>
                                            <div class="d-flex align-items-center justify-content-center">
                                                <div class="d-flex flex-column d-lg-block" v-if="isMonth === false">
                                                    <span class="plans-price">490.000</span>
                                                    <span class="plans-price__text text-uppercase">
                                                        {{ $t('currencyRate.sum') }}
                                                         {{ $t('promoNew.bureaucracy.perMonth') }}
                                                    </span>
                                                </div>
                                                <div class="d-flex flex-column d-lg-block" v-else>
                                                    <span
                                                        class="plans-price"
                                                    >
                                                       4 900.000
                                                    </span>
                                                    <span class="plans-price__text text-uppercase">
                                                         {{ $t('currencyRate.sum') }} / {{ $t('year') }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 d-flex flex-column justify-content-center px-0">
                                            <p class="plans-name rounded premium mx-auto">Premium</p>
                                            <p class="plans-type">{{ $t('promoNew.tariff.bigBusiness') }}</p>
                                            <div class="d-flex align-items-center justify-content-center">
                                                <div class="d-flex flex-column d-lg-block" v-if="isMonth === false">
                                                    <span class="plans-price">990.000</span>
                                                    <span class="plans-price__text text-uppercase">
                                                        {{ $t('currencyRate.sum') }}
                                                         {{ $t('promoNew.bureaucracy.perMonth') }}
                                                    </span>
                                                </div>
                                                <div class="d-flex flex-column d-lg-block" v-else>
                                                    <span
                                                        class="plans-price"
                                                    >
                                                        9 900.000
                                                    </span>
                                                    <span class="plans-price__text text-uppercase">
                                                        {{ $t('currencyRate.sum') }} / {{ $t('year') }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--  Price datas  -->
                    <div class="row width-90 mx-auto">
                        <div class="col-12 px-0">
                            <div class="row mw-100">
                                <div class="col-4 d-none d-md-block">
                                    <table class="table bg-white">
                                        <tbody>
                                        <tr class="table-borderless">
                                            <td class="px-0">
                                                <span class="ml-3">{{ $t('plan.statistics') }}</span>
                                                <a
                                                    href="#!"
                                                    data-placement="right"
                                                    :title="$t('plan.statisticsTitle')"
                                                    role="button"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 6C7.44688 6 7 5.55312 7 5C7 4.44688 7.44688 4 8 4C8.55313 4 9 4.44688 9 5C9 5.55312 8.55313 6 8 6Z"
                                                            fill="#D9D9D9"/>
                                                    </svg>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td class="px-0">
                                                <span class="ml-3">{{ $t('plan.employeesCount') }}</span>
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td class="px-0">
                                                <span class="ml-3">{{ $t('plan.warehousesCount') }}</span>
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td class="px-0">
                                                <span class="ml-3">{{ $t('plan.suppliersCount') }}</span>
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td class="px-0">
                                                <span class="ml-3">{{ $t('plan.customersCount') }}</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-8 d-none d-md-block px-0">
                                    <div class="row">
                                        <!-- Lite -->
                                        <div class="col-4 d-flex flex-column justify-content-center px-0">
                                            <table class="table bg-white">
                                                <tbody>
                                                <tr class="table-borderless">
                                                    <td class="text-center">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.5962 7.19711C16.2057 6.80658 15.5725 6.80658 15.182 7.19711L12 10.3791L8.81802 7.19711C8.4275 6.80658 7.79433 6.80658 7.40381 7.19711L7.05025 7.55066C6.65973 7.94118 6.65973 8.57435 7.05025 8.96487L10.2322 12.1469L6.6967 15.6824C6.30618 16.0729 6.30617 16.7061 6.6967 17.0966L7.05025 17.4502C7.44078 17.8407 8.07394 17.8407 8.46447 17.4502L12 13.9146L15.5355 17.4502C15.9261 17.8407 16.5592 17.8407 16.9497 17.4502L17.3033 17.0966C17.6938 16.7061 17.6938 16.0729 17.3033 15.6824L13.7678 12.1469L16.9497 8.96487C17.3403 8.57435 17.3403 7.94118 16.9497 7.55066L16.5962 7.19711Z"
                                                                  fill="#F95A5A"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">1</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">1</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">50</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">50</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div class="btn local-button mx-auto px-md-3 px-xl-5 py-2" href="#signup"
                                                 @click="showModal('signup')"
                                            >
                                                {{ $t('promoNew.bureaucracy.test') }}
                                            </div>
                                        </div>

                                        <!-- Standard -->
                                        <div class="col-4 d-flex flex-column justify-content-center px-0">
                                            <table class="table bg-white">
                                                <tbody>
                                                <tr class="table-borderless">
                                                    <td class="text-center">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM17.2969 9.79688L11.2969 15.7969C10.8562 16.2375 10.1438 16.2375 9.70781 15.7969L6.70781 12.7969C6.26719 12.3562 6.26719 11.6438 6.70781 11.2078C7.14844 10.7719 7.86094 10.7672 8.29688 11.2078L10.5 13.4109L15.7031 8.20312C16.1437 7.7625 16.8562 7.7625 17.2922 8.20312C17.7281 8.64375 17.7328 9.35625 17.2922 9.79219L17.2969 9.79688Z"
                                                                fill="#4BAE4F"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">10</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">5</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">150</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">150</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div class="btn local-button mx-auto px-md-3 px-xl-5 py-2" href="#signup"
                                                 @click="showModal('signup')"
                                            >
                                                {{ $t('promoNew.bureaucracy.test') }}
                                            </div>
                                        </div>

                                        <!-- Premium -->
                                        <div class="col-4 d-flex flex-column justify-content-center px-0">
                                            <table class="table bg-white">
                                                <tbody>
                                                <tr class="table-borderless">
                                                    <td class="text-center">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM17.2969 9.79688L11.2969 15.7969C10.8562 16.2375 10.1438 16.2375 9.70781 15.7969L6.70781 12.7969C6.26719 12.3562 6.26719 11.6438 6.70781 11.2078C7.14844 10.7719 7.86094 10.7672 8.29688 11.2078L10.5 13.4109L15.7031 8.20312C16.1437 7.7625 16.8562 7.7625 17.2922 8.20312C17.7281 8.64375 17.7328 9.35625 17.2922 9.79219L17.2969 9.79688Z"
                                                                fill="#4BAE4F"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">&infin;</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">&infin;</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">&infin;</td>
                                                </tr>
                                                <tr class="">
                                                    <td class="text-center">&infin;</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div class="btn local-button mx-auto px-md-3 px-xl-5 py-2" href="#signup"
                                                 @click="showModal('signup')"
                                            >
                                                {{ $t('promoNew.bureaucracy.test') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Only seen small devices -->
                        <div class="col-12 d-md-none">
                            <div>
                                <!--Lite-->
                                <div class="mt-5">
                                    <p class="plans-name rounded lite">Lite</p>
                                    <p class="plans-type">{{ $t('promoNew.tariff.smallBusiness') }}</p>
                                    <div
                                        class="d-flex flex-column flex-xl-row align-items-center justify-content-center">
                                        <div v-if="isMonth === false">
                                            <span class="plans-price">49.000</span>
                                            <span class="plans-price__text text-uppercase">
                                                {{ $t('currencyRate.sum') }} {{ $t('promoNew.bureaucracy.perMonth') }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            <span class="plans-price">
                                                490.000
                                            </span>
                                            <span class="plans-price__text text-uppercase">
                                                {{ $t('currencyRate.sum') }} / {{ $t('year') }}
                                            </span>
                                        </div>
                                    </div>
                                    <table class="table bg-white">
                                        <tbody>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.statistics') }}
                                                <b-button
                                                    active-class="no-outline"
                                                    id="popover-Lite"
                                                    variant="white"
                                                    class=" pl-1"
                                                    data-toggle="tooltip" data-placement="right"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 6C7.44688 6 7 5.55312 7 5C7 4.44688 7.44688 4 8 4C8.55313 4 9 4.44688 9 5C9 5.55312 8.55313 6 8 6Z"
                                                            fill="#D9D9D9"/>
                                                    </svg>
                                                </b-button>
                                                <b-popover
                                                    target="popover-Lite"
                                                    placement="bottom"
                                                    triggers="hover focus"
                                                    content="$t('plan.statisticsTitle')"
                                                ></b-popover>
                                            </td>
                                            <td class="text-center">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.5962 7.19711C16.2057 6.80658 15.5725 6.80658 15.182 7.19711L12 10.3791L8.81802 7.19711C8.4275 6.80658 7.79433 6.80658 7.40381 7.19711L7.05025 7.55066C6.65973 7.94118 6.65973 8.57435 7.05025 8.96487L10.2322 12.1469L6.6967 15.6824C6.30618 16.0729 6.30617 16.7061 6.6967 17.0966L7.05025 17.4502C7.44078 17.8407 8.07394 17.8407 8.46447 17.4502L12 13.9146L15.5355 17.4502C15.9261 17.8407 16.5592 17.8407 16.9497 17.4502L17.3033 17.0966C17.6938 16.7061 17.6938 16.0729 17.3033 15.6824L13.7678 12.1469L16.9497 8.96487C17.3403 8.57435 17.3403 7.94118 16.9497 7.55066L16.5962 7.19711Z"
                                                          fill="#F95A5A"/>
                                                </svg>
                                            </td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.employeesCount') }}</td>
                                            <td class="text-center">1</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.warehousesCount') }}</td>
                                            <td class="text-center">1</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.suppliersCount') }}</td>
                                            <td class="text-center">50</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.customersCount') }}</td>
                                            <td class="text-center">50</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn local-button mb-5" @click="showModal('signup')">
                                        {{ $t('promoNew.bureaucracy.test') }}
                                    </div>
                                </div>
                                <!--/Lite-->

                                <!--Standard-->
                                <div class="">
                                    <p class="plans-name rounded standard">Standart</p>
                                    <p class="plans-type">{{ $t('promoNew.tariff.middleBusiness') }}</p>
                                    <div
                                        class="d-flex flex-column flex-xl-row align-items-center justify-content-center">
                                        <div v-if="isMonth === false">
                                            <span class="plans-price">99.000</span>
                                            <span class="plans-price__text text-uppercase">
                                                {{ $t('currencyRate.sum') }} {{ $t('promoNew.bureaucracy.perMonth') }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            <span class="plans-price">
                                                990.000
                                            </span>
                                            <span class="plans-price__text text-uppercase">
                                                 {{ $t('currencyRate.sum') }} / {{ $t('year') }}
                                            </span>
                                        </div>
                                    </div>
                                    <table class="table bg-white">
                                        <tbody>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.statistics') }}
                                                <b-button
                                                    active-class="no-outline"
                                                    id="popover-Standard"
                                                    variant="white"
                                                    class=" pl-1"
                                                    data-toggle="tooltip" data-placement="right"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 6C7.44688 6 7 5.55312 7 5C7 4.44688 7.44688 4 8 4C8.55313 4 9 4.44688 9 5C9 5.55312 8.55313 6 8 6Z"
                                                            fill="#D9D9D9"/>
                                                    </svg>
                                                </b-button>
                                                <b-popover
                                                    target="popover-Standard"
                                                    placement="bottom"
                                                    triggers="hover focus"
                                                    content="$t('plan.statisticsTitle')"
                                                ></b-popover>
                                            </td>
                                            <td class="text-center">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM17.2969 9.79688L11.2969 15.7969C10.8562 16.2375 10.1438 16.2375 9.70781 15.7969L6.70781 12.7969C6.26719 12.3562 6.26719 11.6438 6.70781 11.2078C7.14844 10.7719 7.86094 10.7672 8.29688 11.2078L10.5 13.4109L15.7031 8.20312C16.1437 7.7625 16.8562 7.7625 17.2922 8.20312C17.7281 8.64375 17.7328 9.35625 17.2922 9.79219L17.2969 9.79688Z"
                                                        fill="#4BAE4F"/>
                                                </svg>
                                            </td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.employeesCount') }}</td>
                                            <td class="text-center">10</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.warehousesCount') }}</td>
                                            <td class="text-center">5</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.suppliersCount') }}</td>
                                            <td class="text-center">150</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.customersCount') }}</td>
                                            <td class="text-center">150</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn local-button mb-5" @click="showModal('signup')">
                                        {{ $t('promoNew.bureaucracy.test') }}
                                    </div>
                                </div>
                                <!--/Standard-->

                                <!--Premium-->
                                <div class="">
                                    <p class="plans-name rounded premium">Premium</p>
                                    <p class="plans-type">{{ $t('promoNew.tariff.bigBusiness') }}</p>
                                    <div
                                        class="d-flex flex-column flex-xl-row align-items-center justify-content-center">
                                        <div v-if="isMonth === false">
                                            <span class="plans-price">199.000</span>
                                            <span class="plans-price__text text-uppercase">
                                                {{ $t('currencyRate.sum') }} {{ $t('promoNew.bureaucracy.perMonth') }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            <span class="plans-price">
                                                1 990.000
                                            </span>
                                            <span class="plans-price__text text-uppercase">
                                                {{ $t('currencyRate.sum') }} / {{ $t('year') }}
                                            </span>
                                        </div>
                                    </div>
                                    <table class="table bg-white">
                                        <tbody>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.statistics') }}
                                                <b-button
                                                    active-class="no-outline"
                                                    id="popover-Premium"
                                                    variant="white"
                                                    class=" pl-1"
                                                    data-toggle="tooltip" data-placement="right"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 6C7.44688 6 7 5.55312 7 5C7 4.44688 7.44688 4 8 4C8.55313 4 9 4.44688 9 5C9 5.55312 8.55313 6 8 6Z"
                                                            fill="#D9D9D9"/>
                                                    </svg>
                                                </b-button>
                                                <b-popover
                                                    target="popover-Premium"
                                                    placement="bottom"
                                                    triggers="hover focus"
                                                    content="$t('plan.statisticsTitle')"
                                                ></b-popover>
                                            </td>
                                            <td class="text-center">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM17.2969 9.79688L11.2969 15.7969C10.8562 16.2375 10.1438 16.2375 9.70781 15.7969L6.70781 12.7969C6.26719 12.3562 6.26719 11.6438 6.70781 11.2078C7.14844 10.7719 7.86094 10.7672 8.29688 11.2078L10.5 13.4109L15.7031 8.20312C16.1437 7.7625 16.8562 7.7625 17.2922 8.20312C17.7281 8.64375 17.7328 9.35625 17.2922 9.79219L17.2969 9.79688Z"
                                                        fill="#4BAE4F"/>
                                                </svg>
                                            </td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.employeesCount') }}</td>
                                            <td class="text-center">&infin;</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.warehousesCount') }}</td>
                                            <td class="text-center">&infin;</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.suppliersCount') }}</td>
                                            <td class="text-center">&infin;</td>
                                        </tr>
                                        <tr class="px-0">
                                            <td class="px-0">{{ $t('plan.customersCount') }}</td>
                                            <td class="text-center">&infin;</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn local-button mb-5" @click="showModal('signup')">
                                        {{ $t('promoNew.bureaucracy.test') }}
                                    </div>
                                </div>
                                <!--/Premium-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  /Prices  -->

        <!--  services -->
        <div class="container-fluid">
            <div class="row my-md-5">
                <div class="col-12 mb-3">
                    <p class="custom-title text-center mt-md-5">{{ $t('promoNew.comingSoon.mainText') }}</p>
                </div>
                <div class="col-12 mt-1 col-md-5 p-0 position-relative overflow-hidden">
                    <div class="d-flex align-items-end service-overlay">
                        <h5 class="service-title font-weight-bold text-uppercase text-white pl-3">
                            {{ $t('promoNew.comingSoon.internetStore') }}
                        </h5>
                    </div>
                    <img class="mw-100 h-100 w-100" src="../../public/images/internet-dokon.png" alt="internet do'kon">
                </div>
                <div class="col-12 col-md-4 d-flex flex-column align-items-end p-0 px-md-1">
                    <div class="w-100 h-50 mb-auto mt-1 position-relative overflow-hidden">
                        <div class="d-flex align-items-end service-overlay">
                            <h5 class="service-title font-weight-bold text-uppercase text-white pl-3">
                                {{ $t('promoNew.comingSoon.taxServices') }}</h5>
                        </div>
                        <img class="mw-100 w-100 h-100" src="../../public/images/soliq-xizmatlari.png"
                             alt="soliq xizmatlari">
                    </div>
                    <div class="w-100 h-50 mb-auto mt-1 position-relative overflow-hidden">
                        <div class="d-flex align-items-end service-overlay">
                            <h5 class="service-title font-weight-bold text-uppercase text-white pl-3">
                                {{ $t('promoNew.comingSoon.discounts') }}
                            </h5>
                        </div>
                        <img class="mw-100 w-100 h-100" src="../../public/images/chegirma.png" alt="ajoyib chegirmalar">
                    </div>
                </div>
                <div class="col-12 col-md-3 d-flex justify-content-end mt-1 p-0 overflow-hidden">
                    <div class="d-flex align-items-center service-overlay">
                        <h5 class="service-title font-weight-bold text-uppercase text-white text-center w-100">
                            {{ $t('promoNew.comingSoon.otherServices') }}
                        </h5>
                    </div>
                    <img class="mw-100 mh-100 w-100" src="../../public/images/other-solutions.png"
                         alt="other solutions">
                </div>
            </div>
        </div>
        <!-- /services  -->

        <!--  social networks  -->
        <div class="container-fluid">
            <div class="row">
                <div class="col-6 col-sm-4 col-xl-2 social-network px-1 p-sm-1 p-md-2 ml-xl-5">
                    <a href="https://facebook.com/boshqarCom" target="_blank" class="text-decoration-none">
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="22" r="22" fill="#425894"/>
                            <path
                                d="M34 22.073C34 15.4037 28.629 10 22 10C15.371 10 10 15.4037 10 22.073C10 28.0988 14.3882 33.0935 20.125 34V25.563H17.0766V22.073H20.125V19.4131C20.125 16.3875 21.9153 14.7163 24.6574 14.7163C25.9706 14.7163 27.3439 14.9519 27.3439 14.9519V17.9215H25.8303C24.34 17.9215 23.875 18.8523 23.875 19.8069V22.073H27.2031L26.6708 25.563H23.875V34C29.6118 33.0935 34 28.0988 34 22.073Z"
                                fill="white"/>
                        </svg>
                        <span class="font-weight-bold text-dark">Facebook</span>
                    </a>
                </div>
                <div class="col-6 col-sm-4 col-xl-2 social-network px-1 p-sm-1 p-md-2 ml-xl-4">
                    <a href="https://instagram.com/boshqarCom" target="_blank" class="text-decoration-none">
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="22" r="22" fill="#262626"/>
                            <path
                                d="M22.0027 15.8467C18.5974 15.8467 15.8508 18.594 15.8508 22C15.8508 25.406 18.5974 28.1533 22.0027 28.1533C25.4079 28.1533 28.1546 25.406 28.1546 22C28.1546 18.594 25.4079 15.8467 22.0027 15.8467ZM22.0027 26.0004C19.8021 26.0004 18.0031 24.2064 18.0031 22C18.0031 19.7936 19.7968 17.9996 22.0027 17.9996C24.2086 17.9996 26.0022 19.7936 26.0022 22C26.0022 24.2064 24.2032 26.0004 22.0027 26.0004ZM29.8412 15.595C29.8412 16.3929 29.1987 17.0302 28.4062 17.0302C27.6085 17.0302 26.9713 16.3876 26.9713 15.595C26.9713 14.8024 27.6138 14.1598 28.4062 14.1598C29.1987 14.1598 29.8412 14.8024 29.8412 15.595ZM33.9157 17.0517C33.8247 15.1291 33.3856 13.4261 31.9775 12.023C30.5747 10.6199 28.8721 10.1807 26.9499 10.0843C24.9689 9.97188 19.0311 9.97188 17.0501 10.0843C15.1333 10.1754 13.4307 10.6145 12.0225 12.0176C10.6144 13.4207 10.1807 15.1237 10.0843 17.0463C9.97189 19.0278 9.97189 24.9669 10.0843 26.9483C10.1753 28.8709 10.6144 30.5739 12.0225 31.977C13.4307 33.3801 15.1279 33.8193 17.0501 33.9157C19.0311 34.0281 24.9689 34.0281 26.9499 33.9157C28.8721 33.8246 30.5747 33.3855 31.9775 31.977C33.3803 30.5739 33.8193 28.8709 33.9157 26.9483C34.0281 24.9669 34.0281 19.0331 33.9157 17.0517ZM31.3564 29.0744C30.9388 30.1241 30.1303 30.9327 29.0755 31.3558C27.496 31.9824 23.7481 31.8378 22.0027 31.8378C20.2572 31.8378 16.504 31.977 14.9298 31.3558C13.8804 30.9381 13.0719 30.1294 12.649 29.0744C12.0225 27.4946 12.1671 23.7458 12.1671 22C12.1671 20.2542 12.0279 16.5001 12.649 14.9256C13.0666 13.8759 13.8751 13.0673 14.9298 12.6442C16.5093 12.0176 20.2572 12.1622 22.0027 12.1622C23.7481 12.1622 27.5014 12.023 29.0755 12.6442C30.1249 13.0619 30.9334 13.8706 31.3564 14.9256C31.9828 16.5054 31.8383 20.2542 31.8383 22C31.8383 23.7458 31.9828 27.4999 31.3564 29.0744Z"
                                fill="white"/>
                        </svg>
                        <span class="font-weight-bold text-dark">Instagram</span>
                    </a>
                </div>
                <div class="col-6 col-sm-4 col-xl-2 social-network px-1 p-sm-1 p-md-2 ml-xl-4">
                    <a href="https://t.me/boshqarCom" target="_blank" class="text-decoration-none">
                        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM17.5622 8.16097C17.3816 10.0585 16.6002 14.6631 16.2025 16.7884C16.0343 17.6876 15.7031 17.9892 15.3825 18.0186C14.6857 18.0828 14.1564 17.5581 13.4815 17.1157C12.4253 16.4234 11.8287 15.9924 10.8034 15.3168C9.61868 14.5361 10.3867 14.1071 11.0619 13.4055C11.2386 13.222 14.309 10.4292 14.3685 10.1759C14.3759 10.1442 14.383 10.0259 14.3126 9.96373C14.2423 9.9016 14.1389 9.92265 14.0641 9.93953C13.9582 9.9636 12.271 11.0788 9.00247 13.2851C8.5236 13.614 8.08982 13.7742 7.70114 13.7658C7.27268 13.7565 6.4485 13.5236 5.83577 13.3244C5.08427 13.0801 4.48698 12.951 4.539 12.5361C4.5661 12.32 4.86368 12.099 5.43174 11.8732C8.93 10.349 11.2627 9.34421 12.4299 8.85866C15.7624 7.47252 16.4549 7.23174 16.9062 7.22371C17.0055 7.22206 17.2275 7.24664 17.3712 7.36331C17.4668 7.44641 17.5278 7.56238 17.542 7.68827C17.5664 7.84459 17.5731 8.00314 17.5622 8.16097Z"
                                fill="#4D9FEB"/>
                        </svg>
                        <span class="font-weight-bold text-dark">Telegram</span>
                    </a>
                </div>
                <div class="col-6 col-sm-4 col-xl-2 social-network px-1 p-sm-1 p-md-2 ml-xl-5">
                    <a href="https://www.youtube.com/@boshqarCom" target="_blank" class="text-decoration-none">
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="22" r="22" fill="#BC342B"/>
                            <path
                                d="M33.4985 16.6286C33.2225 15.5939 32.4092 14.7791 31.3766 14.5025C29.505 14 22 14 22 14C22 14 14.495 14 12.6234 14.5025C11.5908 14.7791 10.7775 15.5939 10.5015 16.6286C10 18.5041 10 22.417 10 22.417C10 22.417 10 26.3299 10.5015 28.2053C10.7775 29.24 11.5908 30.0209 12.6234 30.2975C14.495 30.8 22 30.8 22 30.8C22 30.8 29.505 30.8 31.3766 30.2975C32.4092 30.0209 33.2225 29.24 33.4985 28.2053C34 26.3299 34 22.417 34 22.417C34 22.417 34 18.5041 33.4985 16.6286ZM19.5454 25.9696V18.8643L25.8181 22.4171L19.5454 25.9696Z"
                                fill="white"/>
                        </svg>
                        <span class="font-weight-bold text-dark">Youtube</span>
                    </a>
                </div>
                <div class="col-6 col-sm-4 col-xl-2 social-network px-1 p-sm-1 p-md-2 ml-xl-5">
                    <a href="https://play.google.com/store/apps/details?id=org.kadirov.apps.manager&hl=en&gl=US"
                       target="_blank" class="text-decoration-none">
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="22" r="22" fill="#8300C5"/>
                            <path
                                d="M27.0426 20.985L16.7119 10.6095L29.8558 18.1672L27.0426 20.985ZM14.0157 10C13.4072 10.3188 13 10.9002 13 11.655V32.345C13 33.0998 13.4072 33.6812 14.0157 34L26.0268 21.9977L14.0157 10ZM33.9188 20.5771L31.1617 18.9783L28.0864 22.0023L31.1617 25.0264L33.9749 23.4276C34.8175 22.7572 34.8175 21.2475 33.9188 20.5771ZM16.7119 33.3952L29.8558 25.8375L27.0426 23.0197L16.7119 33.3952Z"
                                fill="white"/>
                        </svg>
                        <span class="font-weight-bold text-dark">PlayMarket</span>
                    </a>
                </div>
                <!--                <div class="col-6 col-sm-4 col-xl-2 social-network px-1 p-sm-1 p-md-2">-->
                <!--                    <a href="#!" data-toggle="tooltip" data-placement="top" title="Tez kunda" role="button"-->
                <!--                       class="text-decoration-none">-->
                <!--                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--                            <circle cx="22" cy="22" r="22" fill="#D9D9D9"/>-->
                <!--                            <path-->
                <!--                                d="M28.184 22.6449C28.1738 20.7813 29.0168 19.3746 30.723 18.3387C29.7684 16.9727 28.3262 16.2211 26.4219 16.0738C24.6191 15.9316 22.6488 17.125 21.9277 17.125C21.166 17.125 19.4191 16.1246 18.048 16.1246C15.2145 16.1703 12.2031 18.3844 12.2031 22.8887C12.2031 24.2191 12.4469 25.5936 12.9344 27.0121C13.5844 28.8758 15.9305 33.4461 18.3781 33.3699C19.6578 33.3395 20.5617 32.4609 22.2273 32.4609C23.8422 32.4609 24.6801 33.3699 26.107 33.3699C28.575 33.3344 30.6977 29.1805 31.3172 27.3117C28.0063 25.7527 28.184 22.7414 28.184 22.6449ZM25.3098 14.3066C26.6961 12.6613 26.5691 11.1633 26.5285 10.625C25.3047 10.6961 23.8879 11.4578 23.0805 12.3973C22.1918 13.4027 21.6688 14.6469 21.7805 16.0484C23.1059 16.15 24.3145 15.4695 25.3098 14.3066Z"-->
                <!--                                fill="black"/>-->
                <!--                        </svg>-->
                <!--                        <span class="font-weight-bold text-dark">PlayStore</span>-->
                <!--                    </a>-->
                <!--                </div>-->
            </div>
        </div>
        <!--  /social networks  -->

        <hr class="mb-5" style="width: 90%">

        <!--   Contacts  -->
        <div class="container-fluid">
            <div class="row mb-5 justify-content-center">
                <div class="col-12 col-md-11 col-lg-10 col-xl-7">
                    <div class="row">
                        <div class="col-12 col-md-4 mt-3 d-flex justify-content-md-center">
                            <a href="tel:+998999367070" class="text-decoration-none pl-3 pl-sm-5 pl-md-0">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="12" fill="#6F42C1"/>
                                    <g clip-path="url(#clip0_192_1455)">
                                        <path
                                            d="M9.86484 6.5763C9.68438 6.14036 9.20859 5.90833 8.75391 6.03255L6.69141 6.59505C6.28359 6.70755 6 7.07786 6 7.49973C6 13.2982 10.7016 17.9997 16.5 17.9997C16.9219 17.9997 17.2922 17.7161 17.4047 17.3083L17.9672 15.2458C18.0914 14.7911 17.8594 14.3154 17.4234 14.1349L15.1734 13.1974C14.7914 13.038 14.3484 13.1482 14.0883 13.4693L13.1414 14.6247C11.4914 13.8443 10.1555 12.5083 9.375 10.8583L10.5305 9.9138C10.8516 9.6513 10.9617 9.21067 10.8023 8.82864L9.86484 6.57864V6.5763Z"
                                            fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_192_1455">
                                            <rect width="12" height="12" fill="white" transform="translate(6 6)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <strong class="text-dark">&ensp;+998 99 936-70-70</strong>
                            </a>
                        </div>
                        <div class="col-12 col-md-4 mt-3 d-flex justify-content-md-center">
                            <a href="mailto:info@boshqar.com" class="text-decoration-none pl-3 pl-sm-5 pl-md-0">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="11.5" fill="#F0AD00" stroke="#F0AD00"/>
                                    <path
                                        d="M6.79961 7.19995C6.13711 7.19995 5.59961 7.73745 5.59961 8.39995C5.59961 8.77745 5.77711 9.13245 6.07961 9.35995L11.5196 13.44C11.8046 13.6525 12.1946 13.6525 12.4796 13.44L17.9196 9.35995C18.2221 9.13245 18.3996 8.77745 18.3996 8.39995C18.3996 7.73745 17.8621 7.19995 17.1996 7.19995H6.79961ZM5.59961 9.99995V15.2C5.59961 16.0825 6.31711 16.8 7.19961 16.8H16.7996C17.6821 16.8 18.3996 16.0825 18.3996 15.2V9.99995L12.9596 14.08C12.3896 14.5075 11.6096 14.5075 11.0396 14.08L5.59961 9.99995Z"
                                        fill="white"/>
                                </svg>
                                <strong class="text-dark">&ensp;info@boshqar.com</strong>
                            </a>
                        </div>
                        <div class="col-12 col-md-4 mt-3 d-flex justify-content-md-center">
                            <a href="https://t.me/boshqarComChat" target="_blank"
                               class="text-decoration-none pl-3 pl-sm-5 pl-md-0">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM17.5622 8.16097C17.3816 10.0585 16.6002 14.6631 16.2025 16.7884C16.0343 17.6876 15.7031 17.9892 15.3825 18.0186C14.6857 18.0828 14.1564 17.5581 13.4815 17.1157C12.4253 16.4234 11.8287 15.9924 10.8034 15.3168C9.61868 14.5361 10.3867 14.1071 11.0619 13.4055C11.2386 13.222 14.309 10.4292 14.3685 10.1759C14.3759 10.1442 14.383 10.0259 14.3126 9.96373C14.2423 9.9016 14.1389 9.92265 14.0641 9.93953C13.9582 9.9636 12.271 11.0788 9.00247 13.2851C8.5236 13.614 8.08982 13.7742 7.70114 13.7658C7.27268 13.7565 6.4485 13.5236 5.83577 13.3244C5.08427 13.0801 4.48698 12.951 4.539 12.5361C4.5661 12.32 4.86368 12.099 5.43174 11.8732C8.93 10.349 11.2627 9.34421 12.4299 8.85866C15.7624 7.47252 16.4549 7.23174 16.9062 7.22371C17.0055 7.22206 17.2275 7.24664 17.3712 7.36331C17.4668 7.44641 17.5278 7.56238 17.542 7.68827C17.5664 7.84459 17.5731 8.00314 17.5622 8.16097Z"
                                        fill="#4D9FEB"/>
                                </svg>
                                <strong class="text-dark">&ensp;Telegram Chat</strong>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--   /Contacts  -->

        <hr class="d-md-none mb-5" style="width: 90%">

        <!-- Footer -->
        <div class="container-fluid">
            <div class="row">
                <div class="col mb-5">
                    <div class="footer-logo text-center mb-3">
                        <div class="mb-2">
                            <svg width="29" height="34" viewBox="0 0 29 34" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0.401747 31.1111C0.232031 31.3428 0.0623144 31.5331 0.0283711 31.5331C3.50215 19.5317 9.33825 18.9413 14.8207 18.3866C17.8647 18.0786 20.7997 17.7817 23.1607 15.5487C24.5732 17.1482 26.0584 21.0969 20.6998 24.0952L20.4792 23.9049C20.3604 23.7974 19.4948 23.1934 18.5699 22.5563C17.6449 21.9193 16.3127 21.0009 15.6083 20.5128C14.9125 20.0246 14.31 19.6192 14.2761 19.6192C14.2336 19.6192 14.2082 20.2811 14.2082 21.0919V22.5646L13.2153 22.8707C10.9072 23.5822 8.12384 24.8398 6.34182 25.9567C3.97428 27.446 1.70856 29.4151 0.401747 31.1111Z"
                                    fill="white"/>
                                <path
                                    d="M4.53434 10.6839V5.84388V0.995617L12.1122 1.02044C19.6306 1.04526 19.69 1.05353 20.3604 1.23555C21.6682 2.26698 25.4575 4.64423 20.7338 9.09537L19.7834 8.42521C19.2572 8.06118 18.3408 7.42412 17.7298 7.00217C17.1273 6.58022 16.109 5.88525 15.4811 5.44675C14.8531 5.00826 14.31 4.64423 14.2761 4.64423C14.2336 4.64423 14.2082 5.29783 14.2082 6.09209C14.2082 6.88634 14.1827 7.53995 14.1403 7.53995C13.9197 7.53995 11.5606 7.97845 11.009 8.12737C8.70937 8.73133 6.60488 9.52559 5.06895 10.386L4.53434 10.6839Z"
                                    fill="white"/>
                                <path
                                    d="M20.5471 9.26084L20.7338 9.09537C25.4575 4.64423 21.6682 2.26698 20.3604 1.23555C21.7351 1.59958 23.585 2.71651 24.4421 3.70105C25.8507 5.30611 26.5466 7.06009 26.5381 8.98781C26.5381 10.0303 26.4447 10.6177 26.1562 11.5112C25.7149 12.8681 24.5948 14.4566 23.5001 15.2922L23.1607 15.5487C20.7997 17.7817 17.8647 18.0786 14.8207 18.3866C9.33825 18.9413 3.50215 19.5317 0.0283711 31.5331C-0.064973 31.5331 0.0877718 29.2 0.257488 28.1409C0.987269 23.5161 3.06629 19.3545 6.22302 16.194C7.21586 15.2095 8.78574 13.9602 10.152 13.0749C10.9327 12.5785 13.8687 11.0976 14.0809 11.0976C14.1912 11.0976 14.2082 11.2961 14.2082 12.3386C14.2082 13.017 14.2251 13.5796 14.2506 13.5796C14.3015 13.5796 15.8035 12.5702 17.3055 11.5112C17.8656 11.1224 18.782 10.4936 19.3421 10.113C19.9022 9.73243 20.4453 9.34357 20.5471 9.26084Z"
                                    fill="white"/>
                                <path
                                    d="M20.4877 24.2524L20.6998 24.0952C26.0584 21.0969 24.5732 17.1482 23.1607 15.5487L23.4492 15.7059C25.1464 16.616 25.9526 17.2034 26.7672 18.1466C28.4219 20.0577 29.1772 22.3826 28.965 24.9556C28.8292 26.569 28.3116 27.9507 27.3357 29.3241C26.1817 30.9374 24.51 32.1701 22.6091 32.7989C21.2429 33.254 20.9714 33.2705 14.3609 33.2705C11.009 33.2705 8.2681 33.254 8.2681 33.2291C8.2681 33.0637 8.84514 31.4752 9.0488 31.078C9.66826 29.8784 10.9411 28.2402 11.8915 27.4294C12.7401 26.7096 13.9366 25.9071 14.1657 25.9071C14.1912 25.9071 14.2082 26.5028 14.2082 27.2309C14.2082 27.9589 14.2251 28.5546 14.2421 28.5546C14.2845 28.5546 20.0804 24.5585 20.4877 24.2524Z"
                                    fill="white"/>
                                <path
                                    d="M0.401747 31.1111C0.232031 31.3428 0.0623144 31.5331 0.0283711 31.5331C3.50215 19.5317 9.33825 18.9413 14.8207 18.3866C17.8647 18.0786 20.7997 17.7817 23.1607 15.5487C24.5732 17.1482 26.0584 21.0969 20.6998 24.0952L20.4792 23.9049C20.3604 23.7974 19.4948 23.1934 18.5699 22.5563C17.6449 21.9193 16.3127 21.0009 15.6083 20.5128C14.9125 20.0246 14.31 19.6192 14.2761 19.6192C14.2336 19.6192 14.2082 20.2811 14.2082 21.0919V22.5646L13.2153 22.8707C10.9072 23.5822 8.12384 24.8398 6.34182 25.9567C3.97428 27.446 1.70856 29.4151 0.401747 31.1111Z"
                                    fill="url(#paint0_linear_219_2630)"/>
                                <path
                                    d="M4.53434 10.6839V5.84388V0.995617L12.1122 1.02044C19.6306 1.04526 19.69 1.05353 20.3604 1.23555C21.6682 2.26698 25.4575 4.64423 20.7338 9.09537L19.7834 8.42521C19.2572 8.06118 18.3408 7.42412 17.7298 7.00217C17.1273 6.58022 16.109 5.88525 15.4811 5.44675C14.8531 5.00826 14.31 4.64423 14.2761 4.64423C14.2336 4.64423 14.2082 5.29783 14.2082 6.09209C14.2082 6.88634 14.1827 7.53995 14.1403 7.53995C13.9197 7.53995 11.5606 7.97845 11.009 8.12737C8.70937 8.73133 6.60488 9.52559 5.06895 10.386L4.53434 10.6839Z"
                                    fill="url(#paint1_linear_219_2630)"/>
                                <path
                                    d="M20.5471 9.26084L20.7338 9.09537C25.4575 4.64423 21.6682 2.26698 20.3604 1.23555C21.7351 1.59958 23.585 2.71651 24.4421 3.70105C25.8507 5.30611 26.5466 7.06009 26.5381 8.98781C26.5381 10.0303 26.4447 10.6177 26.1562 11.5112C25.7149 12.8681 24.5948 14.4566 23.5001 15.2922L23.1607 15.5487C20.7997 17.7817 17.8647 18.0786 14.8207 18.3866C9.33825 18.9413 3.50215 19.5317 0.0283711 31.5331C-0.064973 31.5331 0.0877718 29.2 0.257488 28.1409C0.987269 23.5161 3.06629 19.3545 6.22302 16.194C7.21586 15.2095 8.78574 13.9602 10.152 13.0749C10.9327 12.5785 13.8687 11.0976 14.0809 11.0976C14.1912 11.0976 14.2082 11.2961 14.2082 12.3386C14.2082 13.017 14.2251 13.5796 14.2506 13.5796C14.3015 13.5796 15.8035 12.5702 17.3055 11.5112C17.8656 11.1224 18.782 10.4936 19.3421 10.113C19.9022 9.73243 20.4453 9.34357 20.5471 9.26084Z"
                                    fill="url(#paint2_linear_219_2630)"/>
                                <path
                                    d="M20.4877 24.2524L20.6998 24.0952C26.0584 21.0969 24.5732 17.1482 23.1607 15.5487L23.4492 15.7059C25.1464 16.616 25.9526 17.2034 26.7672 18.1466C28.4219 20.0577 29.1772 22.3826 28.965 24.9556C28.8292 26.569 28.3116 27.9507 27.3357 29.3241C26.1817 30.9374 24.51 32.1701 22.6091 32.7989C21.2429 33.254 20.9714 33.2705 14.3609 33.2705C11.009 33.2705 8.2681 33.254 8.2681 33.2291C8.2681 33.0637 8.84514 31.4752 9.0488 31.078C9.66826 29.8784 10.9411 28.2402 11.8915 27.4294C12.7401 26.7096 13.9366 25.9071 14.1657 25.9071C14.1912 25.9071 14.2082 26.5028 14.2082 27.2309C14.2082 27.9589 14.2251 28.5546 14.2421 28.5546C14.2845 28.5546 20.0804 24.5585 20.4877 24.2524Z"
                                    fill="url(#paint3_linear_219_2630)"/>
                                <path
                                    d="M20.5471 9.26084L20.7338 9.09537C25.4575 4.64423 21.6682 2.26698 20.3604 1.23555C21.7351 1.59958 23.585 2.71651 24.4421 3.70105C25.8507 5.30611 26.5466 7.06009 26.5381 8.98781C26.5381 10.0303 26.4447 10.6177 26.1562 11.5112C25.7149 12.8681 24.5948 14.4566 23.5001 15.2922L23.1607 15.5487C20.7997 17.7817 17.8647 18.0786 14.8207 18.3866C9.33825 18.9413 3.50215 19.5317 0.0283711 31.5331C-0.064973 31.5331 0.0877718 29.2 0.257488 28.1409C0.987269 23.5161 3.06629 19.3545 6.22302 16.194C7.21586 15.2095 8.78574 13.9602 10.152 13.0749C10.9327 12.5785 13.8687 11.0976 14.0809 11.0976C14.1912 11.0976 14.2082 11.2961 14.2082 12.3386C14.2082 13.017 14.2251 13.5796 14.2506 13.5796C14.3015 13.5796 15.8035 12.5702 17.3055 11.5112C17.8656 11.1224 18.782 10.4936 19.3421 10.113C19.9022 9.73243 20.4453 9.34357 20.5471 9.26084Z"
                                    fill="url(#paint4_linear_219_2630)"/>
                                <path
                                    d="M0.401747 31.1111C0.232031 31.3428 0.0623144 31.5331 0.0283711 31.5331C3.50215 19.5317 9.33825 18.9413 14.8207 18.3866C17.8647 18.0786 20.7997 17.7817 23.1607 15.5487C24.5732 17.1482 26.0584 21.0969 20.6998 24.0952L20.4792 23.9049C20.3604 23.7974 19.4948 23.1934 18.5699 22.5563C17.6449 21.9193 16.3127 21.0009 15.6083 20.5128C14.9125 20.0246 14.31 19.6192 14.2761 19.6192C14.2336 19.6192 14.2082 20.2811 14.2082 21.0919V22.5646L13.2153 22.8707C10.9072 23.5822 8.12384 24.8398 6.34182 25.9567C3.97428 27.446 1.70856 29.4151 0.401747 31.1111Z"
                                    fill="#8300C5"/>
                                <path
                                    d="M4.53434 10.6839V5.84388V0.995617L12.1122 1.02044C19.6306 1.04526 19.69 1.05353 20.3604 1.23555C21.6682 2.26698 25.4575 4.64423 20.7338 9.09537L19.7834 8.42521C19.2572 8.06118 18.3408 7.42412 17.7298 7.00217C17.1273 6.58022 16.109 5.88525 15.4811 5.44675C14.8531 5.00826 14.31 4.64423 14.2761 4.64423C14.2336 4.64423 14.2082 5.29783 14.2082 6.09209C14.2082 6.88634 14.1827 7.53995 14.1403 7.53995C13.9197 7.53995 11.5606 7.97845 11.009 8.12737C8.70937 8.73133 6.60488 9.52559 5.06895 10.386L4.53434 10.6839Z"
                                    fill="#8300C5"/>
                                <defs>
                                    <linearGradient id="paint0_linear_219_2630" x1="20.2811" y1="33.2622" x2="20.1198"
                                                    y2="15.3914" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#5200B4"/>
                                        <stop offset="1" stop-color="#DC83E7"/>
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_219_2630" x1="20.2811" y1="33.2622" x2="20.1198"
                                                    y2="15.3914" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#5200B4"/>
                                        <stop offset="1" stop-color="#DC83E7"/>
                                    </linearGradient>
                                    <linearGradient id="paint2_linear_219_2630" x1="20.2811" y1="33.2622" x2="20.1198"
                                                    y2="15.3914" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#5200B4"/>
                                        <stop offset="1" stop-color="#DC83E7"/>
                                    </linearGradient>
                                    <linearGradient id="paint3_linear_219_2630" x1="20.2811" y1="33.2622" x2="20.1198"
                                                    y2="15.3914" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#5200B4"/>
                                        <stop offset="1" stop-color="#DC83E7"/>
                                    </linearGradient>
                                    <linearGradient id="paint4_linear_219_2630" x1="20.4933" y1="30.7388" x2="20.5336"
                                                    y2="0.995614" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#5200B4"/>
                                        <stop offset="0.703966" stop-color="#DC83E7"/>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <div>
                            <a href="#">
                                <svg width="145" height="20" viewBox="0 0 145 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M4.71393 14.7745H0L0.0193194 14.5676H0.251152C0.586021 14.5676 0.869372 14.4434 1.10121 14.1951C1.34592 13.9468 1.47471 13.6433 1.48759 13.2846V1.77956C1.48759 1.42089 1.36524 1.1174 1.12052 0.869087C0.875812 0.620776 0.586021 0.496621 0.251152 0.496621H0.0193194L0 0.289696H3.84456C5.17116 0.289696 6.20152 0.606981 6.93566 1.24155C7.6698 1.86233 8.03686 2.69693 8.03686 3.74535C8.03686 4.57305 7.83079 5.26281 7.41864 5.81461C7.0065 6.35261 6.50419 6.71128 5.91173 6.89062C6.92922 7.05616 7.73419 7.5045 8.32666 8.23564C8.91912 8.96677 9.21535 9.89104 9.21535 11.0084C9.21535 12.112 8.81608 13.0156 8.01755 13.7192C7.23189 14.4227 6.13069 14.7745 4.71393 14.7745ZM2.74335 14.0295H4.63665C4.64953 14.0295 4.66241 14.0295 4.67529 14.0295C5.65414 14.0295 6.41404 13.7468 6.95498 13.1812C7.49592 12.6018 7.76639 11.7879 7.76639 10.7394C7.76639 10.1462 7.6698 9.62893 7.4766 9.18749C7.29629 8.73226 7.06446 8.37359 6.78111 8.11148C6.03409 7.44932 4.91356 7.11824 3.41953 7.11824C3.41953 7.11824 3.41309 7.11824 3.40021 7.11824V6.932C3.41309 6.932 3.47105 6.932 3.57409 6.932C3.69 6.932 3.851 6.91821 4.05707 6.89062C4.26314 6.86303 4.49498 6.81475 4.75257 6.74577C5.01016 6.6768 5.24199 6.56644 5.44807 6.41469C5.65414 6.26295 5.84733 6.08361 6.02765 5.87668C6.40116 5.42145 6.58791 4.74549 6.58791 3.84882C6.58791 2.93834 6.3432 2.2279 5.85377 1.71748C5.37723 1.20707 4.68173 0.951857 3.76728 0.951857H2.74335V14.0295Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M13.5201 2.08995C14.8081 0.696649 16.4824 0 18.5431 0C20.6039 0 22.2782 0.696649 23.5662 2.08995C24.8541 3.46945 25.4981 5.2835 25.4981 7.53209C25.4981 9.78068 24.8541 11.6016 23.5662 12.9949C22.2782 14.3744 20.6039 15.0642 18.5431 15.0642C16.4824 15.0642 14.8081 14.3744 13.5201 12.9949C12.245 11.6016 11.6075 9.78068 11.6075 7.53209C11.6075 5.2835 12.245 3.46945 13.5201 2.08995ZM14.5827 12.5397C15.5873 13.8088 16.9074 14.4434 18.5431 14.4434C20.1917 14.4434 21.5119 13.8088 22.5036 12.5397C23.5082 11.2705 24.0105 9.60134 24.0105 7.53209C24.0105 6.16638 23.7851 4.95931 23.3344 3.91089C22.8836 2.86247 22.2396 2.05546 21.4024 1.48986C20.5781 0.910473 19.625 0.620777 18.5431 0.620777C16.9074 0.620777 15.5873 1.25535 14.5827 2.52449C13.5909 3.79364 13.0951 5.46283 13.0951 7.53209C13.0951 9.60134 13.5909 11.2705 14.5827 12.5397Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M27.6211 13.9261C27.5825 13.733 27.5632 13.3605 27.5632 12.8087C27.5632 12.2569 27.6598 11.6706 27.853 11.0498H28.0268C28.014 11.2016 28.0075 11.3533 28.0075 11.5051C28.0075 12.3466 28.2458 13.0501 28.7223 13.6157C29.1989 14.1675 29.83 14.4434 30.6156 14.4434C31.4271 14.4434 32.0904 14.1813 32.6055 13.6571C33.1336 13.1329 33.3976 12.4776 33.3976 11.6913C33.3976 10.8912 33.1465 10.2428 32.6442 9.74619L28.9349 6.06292C28.2394 5.37317 27.8916 4.53857 27.8916 3.55912C27.8916 2.57967 28.1943 1.74507 28.7996 1.05532C29.4178 0.351773 30.2486 0 31.2918 0C31.7812 0 32.3351 0.0689751 32.9533 0.206925H33.7067V2.75211H33.5329C33.5329 2.10374 33.3204 1.58643 32.8953 1.20017C32.4832 0.813908 31.9487 0.620777 31.2918 0.620777C30.635 0.620777 30.0811 0.855293 29.6304 1.32432C29.1924 1.79335 28.9735 2.37964 28.9735 3.08319C28.9735 3.78674 29.2311 4.39372 29.7463 4.90413L33.5522 8.67018C34.1962 9.30475 34.5182 10.1738 34.5182 11.2774C34.5182 12.381 34.1897 13.2915 33.5329 14.0089C32.876 14.7124 32.0002 15.0642 30.9054 15.0642C30.3387 15.0642 29.7334 14.9676 29.0894 14.7745C28.4583 14.5951 27.9689 14.3123 27.6211 13.9261Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M46.1795 14.5676C46.5144 14.5676 46.7977 14.4434 47.0296 14.1951C47.2743 13.9468 47.4031 13.6433 47.416 13.2846V7.92525H39.5143V13.2639C39.5143 13.6226 39.6367 13.933 39.8814 14.1951C40.1261 14.4434 40.4159 14.5676 40.7508 14.5676H41.0019V14.7745H36.771V14.5676H37.0221C37.357 14.5676 37.6404 14.4434 37.8722 14.1951C38.1169 13.933 38.2457 13.6226 38.2586 13.2639V1.77956C38.2457 1.42089 38.1169 1.1174 37.8722 0.869087C37.6404 0.620776 37.357 0.496621 37.0221 0.496621H36.771V0.289696H41.0019V0.496621H40.7508C40.4159 0.496621 40.1261 0.620776 39.8814 0.869087C39.6496 1.1174 39.5272 1.42089 39.5143 1.77956V7.30447H47.416V1.77956C47.4031 1.28294 47.197 0.910472 46.7977 0.662162C46.6045 0.551801 46.3985 0.496621 46.1795 0.496621H45.9284V0.289696H50.1593V0.496621H49.9082C49.5733 0.496621 49.2835 0.627674 49.0388 0.889781C48.807 1.13809 48.6846 1.44158 48.6717 1.80025V13.2639C48.6846 13.6226 48.807 13.933 49.0388 14.1951C49.2835 14.4434 49.5733 14.5676 49.9082 14.5676H50.1593V14.7745H45.9284V14.5676H46.1795Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M75.969 17.5887C75.647 17.9611 75.1897 18.3198 74.5973 18.6647C74.0048 19.0234 73.4059 19.2855 72.8006 19.451C72.1952 19.6303 71.6607 19.72 71.1971 19.72C69.703 19.72 68.2863 19.4096 66.9468 18.7888C66.4703 18.5681 65.6653 18.1474 64.5319 17.5266C61.9946 16.1333 60.0949 15.3125 58.8327 15.0642C56.8363 15.009 55.2135 14.2917 53.9642 12.9122C52.7277 11.5326 52.1095 9.7324 52.1095 7.5114C52.1095 5.2766 52.7471 3.46945 54.0221 2.08995C55.3101 0.696649 56.9844 0 59.0452 0C61.1059 0 62.7738 0.696649 64.0489 2.08995C65.324 3.46945 65.9615 5.2835 65.9615 7.53209C65.9615 9.4496 65.485 11.0636 64.5319 12.3741C63.5788 13.6847 62.3037 14.5193 60.7066 14.8779C62.1105 15.3332 64.2421 16.2161 67.1014 17.5266C68.4666 18.1336 69.8576 18.4371 71.2744 18.4371C72.0729 18.4371 72.8779 18.3336 73.6893 18.1267C74.8227 17.8094 75.7693 17.2714 76.5292 16.5127L76.6065 16.6161C76.5035 16.9058 76.291 17.23 75.969 17.5887ZM59.0452 0.620777C57.3966 0.620777 56.07 1.25535 55.0654 2.52449C54.0608 3.79364 53.5585 5.46283 53.5585 7.53209C53.5585 9.60134 54.0608 11.2705 55.0654 12.5397C56.0829 13.8088 57.4095 14.4434 59.0452 14.4434C60.6938 14.4434 62.0139 13.8088 63.0057 12.5397C64.0103 11.2705 64.5126 9.60134 64.5126 7.53209C64.5126 6.16638 64.2872 4.95931 63.8364 3.91089C63.3856 2.86247 62.7416 2.05546 61.9044 1.48986C61.0802 0.910473 60.1271 0.620777 59.0452 0.620777Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M80.2725 14.5676H80.4271V14.7745H76.0802V14.5676H76.2541C76.5245 14.5676 76.7242 14.4779 76.853 14.2986C76.9946 14.1054 77.0655 13.9261 77.0655 13.7605C77.0655 13.595 77.0397 13.4295 76.9882 13.2639L75.7518 9.74619H70.5355L69.2411 13.2846C69.1896 13.4502 69.1639 13.6157 69.1639 13.7812C69.1639 13.933 69.2283 14.1054 69.3571 14.2986C69.4987 14.4779 69.7048 14.5676 69.9753 14.5676H70.1491V14.7745H66.266V14.5676H66.4398C66.7618 14.5676 67.0774 14.4572 67.3865 14.2365C67.6956 14.0158 67.9467 13.6916 68.1399 13.2639L72.5061 2.13133C72.9827 1.01394 73.2209 0.303491 73.2209 0H73.3948L78.5724 13.2639C78.7527 13.6916 78.9974 14.0158 79.3065 14.2365C79.6156 14.4572 79.9376 14.5676 80.2725 14.5676ZM70.7674 9.12542H75.5199L73.2016 2.48311L70.7674 9.12542Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M85.3325 0.931165H84.0961V13.2639C84.0961 13.6226 84.212 13.933 84.4438 14.1951C84.6885 14.4434 84.9848 14.5676 85.3325 14.5676H85.5644L85.5837 14.7745H81.3527V14.5676H81.6039C81.9388 14.5676 82.2221 14.4434 82.4539 14.1951C82.6987 13.9468 82.8274 13.6433 82.8403 13.2846V1.80025C82.8274 1.44158 82.6987 1.13809 82.4539 0.889781C82.2221 0.627674 81.9388 0.496621 81.6039 0.496621H81.3527V0.289696H86.569C87.741 0.289696 88.6619 0.641469 89.3316 1.34502C90.0014 2.03477 90.3362 2.93834 90.3362 4.05574C90.3362 5.15934 90.0143 6.1181 89.3703 6.932C88.7392 7.73212 87.9664 8.13217 87.0519 8.13217C87.2451 8.22874 87.4705 8.42187 87.7281 8.71156C87.9986 8.98746 88.2369 9.27716 88.4429 9.58065C89.5506 11.2774 90.2718 12.3259 90.6067 12.7259C90.9416 13.1122 91.1798 13.3812 91.3215 13.5329C91.4632 13.6709 91.6178 13.8088 91.7852 13.9468C91.9526 14.0847 92.1201 14.1951 92.2875 14.2779C92.661 14.471 93.0603 14.5676 93.4853 14.5676V14.7745H92.4227C91.8689 14.7745 91.3537 14.671 90.8772 14.4641C90.4006 14.2434 90.04 14.0227 89.7953 13.8019C89.5635 13.5674 89.3574 13.3467 89.1771 13.1398C89.0097 12.919 88.5331 12.2017 87.7474 10.9877C86.9618 9.77378 86.5046 9.08403 86.3758 8.91849C86.247 8.73915 86.1117 8.56672 85.9701 8.40118C85.5579 7.93214 85.1458 7.69763 84.7336 7.69763V7.4907C84.8367 7.5045 84.9719 7.5114 85.1393 7.5114C85.3068 7.5114 85.5128 7.5045 85.7576 7.4907C87.3546 7.44932 88.3592 6.73198 88.7714 5.33868C88.8486 5.06278 88.8873 4.80757 88.8873 4.57305C88.8873 4.32474 88.8873 4.1661 88.8873 4.09713C88.8615 3.17286 88.6361 2.42793 88.2111 1.86233C87.7861 1.29673 87.2129 0.993243 86.4917 0.951857C86.1826 0.938063 85.7962 0.931165 85.3325 0.931165Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M95.6251 14.5882C95.4576 14.7676 95.2516 14.8573 95.0069 14.8573C94.7621 14.8573 94.5561 14.7676 94.3886 14.5882C94.2212 14.4089 94.1375 14.1882 94.1375 13.9261C94.1375 13.664 94.2212 13.4433 94.3886 13.2639C94.5561 13.0846 94.7621 12.9949 95.0069 12.9949C95.2516 12.9949 95.4576 13.0846 95.6251 13.2639C95.7925 13.4433 95.8762 13.664 95.8762 13.9261C95.8762 14.1882 95.7925 14.4089 95.6251 14.5882Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M104.777 15.0642C102.742 15.0504 101.08 14.3537 99.7925 12.9742C98.5174 11.5947 97.8799 9.78068 97.8799 7.53209C97.8799 5.2697 98.5174 3.44876 99.7925 2.06926C101.08 0.689752 102.781 0 104.893 0C106.619 0 108.145 0.469031 109.471 1.40709L109.858 4.32474H109.684C109.401 3.13837 108.828 2.2279 107.965 1.59333C107.102 0.94496 106.078 0.620777 104.893 0.620777C103.206 0.620777 101.853 1.24845 100.836 2.5038C99.8311 3.75915 99.3288 5.42145 99.3288 7.4907C99.3288 9.55996 99.8247 11.2292 100.816 12.4983C101.821 13.7536 103.141 14.402 104.777 14.4434C106.219 14.4434 107.424 14.0227 108.39 13.1812C109.433 12.2707 110.064 10.7877 110.283 8.73226H110.437L110.206 11.981C109.034 14.0364 107.224 15.0642 104.777 15.0642Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M114.664 2.08995C115.952 0.696649 117.626 0 119.687 0C121.748 0 123.422 0.696649 124.71 2.08995C125.998 3.46945 126.642 5.2835 126.642 7.53209C126.642 9.78068 125.998 11.6016 124.71 12.9949C123.422 14.3744 121.748 15.0642 119.687 15.0642C117.626 15.0642 115.952 14.3744 114.664 12.9949C113.389 11.6016 112.751 9.78068 112.751 7.53209C112.751 5.2835 113.389 3.46945 114.664 2.08995ZM115.726 12.5397C116.731 13.8088 118.051 14.4434 119.687 14.4434C121.336 14.4434 122.656 13.8088 123.647 12.5397C124.652 11.2705 125.154 9.60134 125.154 7.53209C125.154 6.16638 124.929 4.95931 124.478 3.91089C124.027 2.86247 123.383 2.05546 122.546 1.48986C121.722 0.910473 120.769 0.620777 119.687 0.620777C118.051 0.620777 116.731 1.25535 115.726 2.52449C114.735 3.79364 114.239 5.46283 114.239 7.53209C114.239 9.60134 114.735 11.2705 115.726 12.5397Z"
                                        fill="#5200B4"/>
                                    <path
                                        d="M144.691 14.5676H145V14.7745H140.808V14.5882H141.097C141.316 14.5882 141.503 14.4986 141.658 14.3192C141.812 14.1261 141.877 13.9192 141.851 13.6985L140.982 3.29012L136.924 12.9535C136.564 13.795 136.345 14.4986 136.268 15.0642H136.074L131.129 3.57981L130.298 13.6985C130.272 13.9192 130.337 14.1261 130.491 14.3192C130.646 14.4986 130.826 14.5882 131.032 14.5882H131.341V14.7745H127.593V14.5676H127.902C128.263 14.5676 128.572 14.4503 128.83 14.2158C129.1 13.9813 129.261 13.664 129.313 13.2639L130.762 0H130.955L136.345 12.4776L141.619 0H141.793L143.281 13.2639C143.345 13.8157 143.603 14.202 144.053 14.4227C144.247 14.5193 144.459 14.5676 144.691 14.5676Z"
                                        fill="#5200B4"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                    <p class="footer-text text-center px-2 px-lg-5">
                        {{ $t('promoNew.gratitude') }}
                    </p>
                </div>
            </div>
        </div>
        <!-- /Footer -->

        <b-modal id="login" :title="$t('login.title')" title-class="pl-4" hide-footer>
            <form class="p-4">
                <div class="d-flex">
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1.5 0C0.671875 0 0 0.671875 0 1.5C0 1.97188 0.221875 2.41562 0.6 2.7L7.4 7.8C7.75625 8.06563 8.24375 8.06563 8.6 7.8L15.4 2.7C15.7781 2.41562 16 1.97188 16 1.5C16 0.671875 15.3281 0 14.5 0H1.5ZM0 3.5V10C0 11.1031 0.896875 12 2 12H14C15.1031 12 16 11.1031 16 10V3.5L9.2 8.6C8.4875 9.13438 7.5125 9.13438 6.8 8.6L0 3.5Z"
                            fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="email"
                        class="no-outline"
                        id="email"
                        name="email"
                        placeholder="Email"
                        v-model="modelForm.email"
                    >
                </div>
                <div class="d-flex mb-4">
                    <svg width="15" height="17" viewBox="0 0 15 17" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M3 3C3 1.34315 4.34315 0 6 0H9C10.6569 0 12 1.34315 12 3V6C13.6569 6 15 7.34315 15 9V14C15 15.6569 13.6569 17 12 17H3C1.34315 17 0 15.6569 0 14V9C0 7.34315 1.34315 6 3 6V3ZM5 6H10V3C10 2.44772 9.55228 2 9 2H6C5.44772 2 5 2.44772 5 3V6ZM8.24356 10.803C8.69546 10.5446 9 10.0579 9 9.5C9 8.67157 8.32843 8 7.5 8C6.67157 8 6 8.67157 6 9.5C6 10.0579 6.30454 10.5446 6.75644 10.803L5.33494 14.25H9.66506L8.24356 10.803Z"
                              fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="password"
                        class="no-outline"
                        id="password"
                        name="password"
                        placeholder="Parol"
                        v-model="modelForm.password"
                    >

                </div>
                <router-link class="local-link" :to="$i18nHelper.getUrl('forgot-password')">
                    {{ $t('user.forgotPassword') }}
                </router-link>
                <button type="button" class="form-control btn local-button mt-3 mb-3"
                        @click="login">
                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                    {{ $t('loginSystem') }}
                </button>
                <span v-if="$i18n.locale === 'uz'">Akkauntingiz bo'lmasa:
                    <a href="#signup"
                       class="local-link"
                       type="button"
                       @click="hideModal('login'), showModal('signup')"
                    >
                        Ro'yxatdan o'ting
                    </a>
                </span>
                <span v-else-if="$i18n.locale === 'ru'">Если у вас нет аккаунта:
                    <a href="#signup"
                       class="local-link"
                       type="button"
                       @click="hideModal('login'), showModal('signup')"
                    >
                        Пройдите регистрацию
                    </a>
                </span>
                <span v-else>If you don't have an account:
                    <a href="#signup"
                       class="local-link"
                       type="button"
                       @click="hideModal('login'), showModal('signup')"
                    >
                        Register
                    </a>
                </span>
            </form>
        </b-modal>
        <b-modal id="signup" :title="$t('company.create')" title-tag="h4" title-class="pl-2 pl-sm-4" hide-footer>
            <form method="post" class="p-2 p-sm-4">
                <div class="d-flex">
                    <svg width="13" height="17" viewBox="0 0 13 17" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1.59375 0C0.713867 0 0 0.713867 0 1.59375V15.4062C0 16.2861 0.713867 17 1.59375 17H4.78125V14.3438C4.78125 13.4639 5.49512 12.75 6.375 12.75C7.25488 12.75 7.96875 13.4639 7.96875 14.3438V17H11.1562C12.0361 17 12.75 16.2861 12.75 15.4062V1.59375C12.75 0.713867 12.0361 0 11.1562 0H1.59375ZM2.125 7.96875C2.125 7.67656 2.36406 7.4375 2.65625 7.4375H3.71875C4.01094 7.4375 4.25 7.67656 4.25 7.96875V9.03125C4.25 9.32344 4.01094 9.5625 3.71875 9.5625H2.65625C2.36406 9.5625 2.125 9.32344 2.125 9.03125V7.96875ZM5.84375 7.4375H6.90625C7.19844 7.4375 7.4375 7.67656 7.4375 7.96875V9.03125C7.4375 9.32344 7.19844 9.5625 6.90625 9.5625H5.84375C5.55156 9.5625 5.3125 9.32344 5.3125 9.03125V7.96875C5.3125 7.67656 5.55156 7.4375 5.84375 7.4375ZM8.5 7.96875C8.5 7.67656 8.73906 7.4375 9.03125 7.4375H10.0938C10.3859 7.4375 10.625 7.67656 10.625 7.96875V9.03125C10.625 9.32344 10.3859 9.5625 10.0938 9.5625H9.03125C8.73906 9.5625 8.5 9.32344 8.5 9.03125V7.96875ZM2.65625 3.1875H3.71875C4.01094 3.1875 4.25 3.42656 4.25 3.71875V4.78125C4.25 5.07344 4.01094 5.3125 3.71875 5.3125H2.65625C2.36406 5.3125 2.125 5.07344 2.125 4.78125V3.71875C2.125 3.42656 2.36406 3.1875 2.65625 3.1875ZM5.3125 3.71875C5.3125 3.42656 5.55156 3.1875 5.84375 3.1875H6.90625C7.19844 3.1875 7.4375 3.42656 7.4375 3.71875V4.78125C7.4375 5.07344 7.19844 5.3125 6.90625 5.3125H5.84375C5.55156 5.3125 5.3125 5.07344 5.3125 4.78125V3.71875ZM9.03125 3.1875H10.0938C10.3859 3.1875 10.625 3.42656 10.625 3.71875V4.78125C10.625 5.07344 10.3859 5.3125 10.0938 5.3125H9.03125C8.73906 5.3125 8.5 5.07344 8.5 4.78125V3.71875C8.5 3.42656 8.73906 3.1875 9.03125 3.1875Z"
                            fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="text"
                        class="no-outline"
                        id="company"
                        name="company"
                        placeholder="Korxona/Kompaniya nomi"
                        v-model="modelForm.companyName"
                    >
                    <b-form-invalid-feedback style="border: none; color: red; width: 10%"
                                             :state="modelNotEmptyState('companyName')"
                                             class="my-auto mr-2"
                    >
                        <span class="float-right" style="font-size: 26px;">*</span>
                    </b-form-invalid-feedback>
                </div>
                <div class="d-flex">
                    <svg width="15" height="18" viewBox="0 0 15 18" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 8.82353C9.86719 8.82353 11.7857 6.84858 11.7857 4.41177C11.7857 1.97495 9.86719 0 7.5 0C5.13281 0 3.21429 1.97495 3.21429 4.41177C3.21429 6.84858 5.13281 8.82353 7.5 8.82353ZM5.96987 10.4779C2.67188 10.4779 0 13.2284 0 16.6234C0 17.1887 0.445313 17.6471 0.99442 17.6471H14.0056C14.5547 17.6471 15 17.1887 15 16.6234C15 13.2284 12.3281 10.4779 9.03013 10.4779H5.96987Z"
                            fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="text"
                        class="no-outline"
                        id="givenName"
                        name="givenName"
                        placeholder="Ismingiz"
                        v-model="modelForm.givenName"
                    >
                    <b-form-invalid-feedback style="border: none; color: red; width: 10%"
                                             :state="modelNotEmptyState('givenName')"
                                             class="my-auto mr-2"
                    >
                        <span class="float-right" style="font-size: 26px;">*</span>
                    </b-form-invalid-feedback>
                </div>
                <div class="d-flex">
                    <svg width="15" height="18" viewBox="0 0 15 18" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 8.82353C9.86719 8.82353 11.7857 6.84858 11.7857 4.41177C11.7857 1.97495 9.86719 0 7.5 0C5.13281 0 3.21429 1.97495 3.21429 4.41177C3.21429 6.84858 5.13281 8.82353 7.5 8.82353ZM5.96987 10.4779C2.67188 10.4779 0 13.2284 0 16.6234C0 17.1887 0.445313 17.6471 0.99442 17.6471H14.0056C14.5547 17.6471 15 17.1887 15 16.6234C15 13.2284 12.3281 10.4779 9.03013 10.4779H5.96987Z"
                            fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="text"
                        class="no-outline"
                        id="familyName"
                        name="familyName"
                        placeholder="Familiya"
                        v-model="modelForm.familyName"
                    >
                </div>
                <div class="d-flex">
                    <svg width="18" height="16" viewBox="0 0 16 16" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.15312 0.768478C4.9125 0.187228 4.27812 -0.122147 3.67188 0.0434781L0.921875 0.793478C0.378125 0.943478 0 1.43723 0 1.99973C0 9.73098 6.26875 15.9997 14 15.9997C14.5625 15.9997 15.0563 15.6216 15.2063 15.0779L15.9563 12.3279C16.1219 11.7216 15.8125 11.0872 15.2312 10.8466L12.2312 9.5966C11.7219 9.3841 11.1313 9.53098 10.7844 9.9591L9.52188 11.4997C7.32188 10.4591 5.54063 8.67785 4.5 6.47785L6.04063 5.21848C6.46875 4.86848 6.61562 4.28098 6.40312 3.7716L5.15312 0.771603V0.768478Z"
                            fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="text"
                        class="no-outline"
                        id="phone"
                        name="phone"
                        placeholder="Telefon raqami"
                        v-model="modelForm.telephone"
                    >
                    <b-form-invalid-feedback style="border: none; color: red; width: 10%"
                                             :state="modelPhoneOrEmpty('telephone')"
                                             class="my-auto mr-2"
                    >
                        <span class="float-right" style="font-size: 26px;">*</span>
                    </b-form-invalid-feedback>
                </div>

                <div v-if="modelForm.partnerId" class="d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" fill="none" class="bi bi-person-check-fill" viewBox="0 0 18 18">
                        <path fill-rule="evenodd" d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z" fill="#7E7E7E"/>
                        <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="text"
                        class="no-outline"
                        readonly
                        name="managerId"
                        v-model="modelForm.partnerId"
                    >
                </div>

                <div class="d-flex">
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1.5 0C0.671875 0 0 0.671875 0 1.5C0 1.97187 0.221875 2.41562 0.6 2.7L7.4 7.8C7.75625 8.06563 8.24375 8.06563 8.6 7.8L15.4 2.7C15.7781 2.41562 16 1.97187 16 1.5C16 0.671875 15.3281 0 14.5 0H1.5ZM0 3.5V10C0 11.1031 0.896875 12 2 12H14C15.1031 12 16 11.1031 16 10V3.5L9.2 8.6C8.4875 9.13438 7.5125 9.13438 6.8 8.6L0 3.5Z"
                            fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="email"
                        class="no-outline"
                        id="signUpEmail"
                        name="signUpEmail"
                        placeholder="Email"
                        v-model="modelForm.email"
                    >
                    <b-form-invalid-feedback style="border: none; color: red; width: 10%"
                                             :state="modelEmailState('email')"
                                             class="my-auto mr-2"
                    >
                        <span class="float-right" style="font-size: 26px;">*</span>
                    </b-form-invalid-feedback>
                </div>
                <div>
                    <span class="d-flex">
                        <svg width="15" height="17" viewBox="0 0 15 17" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M3 3C3 1.34315 4.34315 0 6 0H9C10.6569 0 12 1.34315 12 3V6C13.6569 6 15 7.34315 15 9V14C15 15.6569 13.6569 17 12 17H3C1.34315 17 0 15.6569 0 14V9C0 7.34315 1.34315 6 3 6V3ZM5 6H10V3C10 2.44772 9.55228 2 9 2H6C5.44772 2 5 2.44772 5 3V6ZM8.24356 10.803C8.69546 10.5446 9 10.0579 9 9.5C9 8.67157 8.32843 8 7.5 8C6.67157 8 6 8.67157 6 9.5C6 10.0579 6.30454 10.5446 6.75644 10.803L5.33494 14.25H9.66506L8.24356 10.803Z"
                              fill="#7E7E7E"/>
                        </svg>
                        <input
                            type="password"
                            class="no-outline"
                            id="signUpPassword"
                            name="signUpPassword"
                            placeholder="Parol"
                            v-model="modelForm.plainPassword"
                        />
                        <b-form-invalid-feedback style="border: none; color: red; width: 10%"
                                                 :state="modelStrongPassword('plainPassword')"
                                                 class="my-auto mr-2"
                        >
                            <span class="float-right" style="font-size: 26px;">*</span>
                        </b-form-invalid-feedback>
                    </span>

                    <span
                        v-if="!modelStrongPassword('plainPassword') && modelForm.plainPassword.length > 0"
                        style="font-size: 12px; color: #e86b6b;"
                        class="pb-2 pl-3"
                    >
                        {{ $t('validator.type.strongPassword') }}
                    </span>
                </div>
                <div class="d-flex mb-4">
                    <svg width="15" height="17" viewBox="0 0 15 17" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M3 3C3 1.34315 4.34315 0 6 0H9C10.6569 0 12 1.34315 12 3V6C13.6569 6 15 7.34315 15 9V14C15 15.6569 13.6569 17 12 17H3C1.34315 17 0 15.6569 0 14V9C0 7.34315 1.34315 6 3 6V3ZM5 6H10V3C10 2.44772 9.55228 2 9 2H6C5.44772 2 5 2.44772 5 3V6ZM8.24356 10.803C8.69546 10.5446 9 10.0579 9 9.5C9 8.67157 8.32843 8 7.5 8C6.67157 8 6 8.67157 6 9.5C6 10.0579 6.30454 10.5446 6.75644 10.803L5.33494 14.25H9.66506L8.24356 10.803Z"
                              fill="#7E7E7E"/>
                    </svg>
                    <input
                        type="password"
                        class="no-outline"
                        placeholder="Parolni takrorlash"
                        v-model="testPassword"
                    />
                    <span style="border: none; color: red; width: 10%" v-if="!isPasswordSame()" class="my-auto mr-2">
                        <span class="float-right" style="font-size: 26px;">*</span>
                    </span>
                </div>
                <button
                    type="button"
                    class="form-control btn local-button mt-3 mb-3"
                    @click="add"
                    :disabled="!buttonDisabled"
                >
                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                    {{ $t('company.create') }}
                </button>
                <span v-if="$i18n.locale === 'uz'">Agar akkauntingiz bo'lsa:
                    <a href="#login"
                       class="local-link"
                       type="button"
                       @click="hideModal('signup'), showModal('login')"
                    >
                        Kirish sahifasiga o'ting

                    </a>
                </span>
                <span v-else-if="$i18n.locale === 'ru'">Если у вас есть аккаунт:
                    <a href="#login"
                       class="local-link"
                       type="button"
                       @click="hideModal('signup'), showModal('login')"
                    >Перейти на страницу входа
                    </a>
                </span>
                <span v-else>If you have an account:
                    <a href="#login"
                       class="local-link"
                       type="button"
                       @click="hideModal('signup'), showModal('login')"
                    >Go to the login page
                    </a>
                </span>
            </form>
        </b-modal>
        <Modal
            :text="modalText"
            id="modal_show"
        />
    </div>
</template>

<script>

import loginMixin from "@/mixin/loginMixin";
import validatorMixin from "@/mixin/validatorMixin";
import Modal from "@/components/html/Modal";
import {mapActions, mapGetters} from "vuex";
import PromoLanguageSwitcher from "@/components/PromoLanguageSwitcher.vue";
import {getPartner, setPartner} from "@/store/local/localStoragePartner";

export default {
    name: "Promo",
    mixins: [loginMixin, validatorMixin],
    watch: {
        'modelForm.companyName'() {
            this.errorsAdd.companyName = this.modelNotEmptyState('companyName')
            this.registrationDisabled()
        },
        'modelForm.givenName'() {
            this.errorsAdd.givenName = this.modelNotEmptyState('givenName')
            this.registrationDisabled()
        },
        'modelForm.email'() {
            this.errorsAdd.email = this.modelEmailState('email')
            this.registrationDisabled()
        },
        'modelForm.plainPassword'() {
            this.errorsAdd.plainPassword = this.modelStrongPassword('plainPassword')
            this.registrationDisabled()
        },
        'modelForm.telephone'() {
            this.errorsAdd.telephone = this.modelPhoneOrEmpty('telephone')
            this.registrationDisabled()
        },
        testPassword() {
            this.errorsAdd.plainPassword2 = this.isPasswordSame()
            this.registrationDisabled()
        },
    },
    data() {
        return {
            titlePopover1: "Saytda o'zingiz ro'yxatdan o'tayotgan bo'lsangiz, ushbu maydonchani bo'sh qoldiring.",
            titlePopover2: "Agar menejerimiz do'koningizga borib ro'yxatdan o'tkazib bersa, uning o'zi ID raqamini kiritadi.",
            buttonDisabled: false,
            isMonth: false,
            modalText: '',
            showNavbar: false,
            isLoading: false,
            testPassword: '',
            errors: {
                email: null,
                password: null,
            },
            errorsAdd: {
                companyName: false,
                givenName: false,
                email: false,
                plainPassword: false,
                plainPassword2: false,
                telephone: false,
            },
            modelForm: {
                email: '',
                password: '',
                companyName: '',
                familyName: '',
                givenName: '',
                plainPassword: '',
                telephone: '',
                partnerId: null,
                isManager: false
            },
        }
    },
    computed: {
        ...mapGetters(['isEmailAvailable']),
    },
    methods: {
        ...mapActions(['pushCompany', 'checkEmailAvailability']),
        scrollToBottom(element) {
            this.$refs[element].scrollIntoView({behavior: "smooth"})
        },
        isPasswordSame() {
            return this.testPassword === this.modelForm.plainPassword;
        },
        showModal(modalName) {
            this.$bvModal.show(modalName)
        },
        hideModal(modalName) {
            this.$bvModal.hide(modalName)
        },
        registrationDisabled() {
            this.buttonDisabled = this.errorsAdd.companyName
                && this.errorsAdd.givenName
                && this.errorsAdd.email
                && this.errorsAdd.telephone
                && this.errorsAdd.plainPassword
                && this.errorsAdd.plainPassword2;
        },
        add() {
            this.checkEmailAvailability(this.modelForm.email)
                .then(() => {
                    this.isLoading = true

                    if (!this.isEmailAvailable) {
                        this.isLoading = false
                        this.modelForm.email = ''
                        this.modalText = this.$t("user.errors.emailExists")
                        this.$bvModal.show('modal_show')
                        return
                    }

                    this.modelForm.partnerId = parseInt(this.modelForm.partnerId)
                    this.pushCompany(this.modelForm)
                        .then(() => {
                            this.$bvModal.hide('signup')
                            this.modelForm.password = this.modelForm.plainPassword
                            this.modelForm.isManager = false
                            this.login()
                            this.modelForm.plainPassword = ''
                        })
                        .catch((reason) => {
                            if (reason === 'Partner is not found') {
                                this.modalText = this.$t('company.managerError')
                                this.$bvModal.show('modal_show')
                                this.isLoading = false
                            } else {
                                this.isLoading = false
                                this.modalText = reason
                                this.$bvModal.show('modal_show')
                            }
                        })
                })
                .catch((reason) => {
                    if (reason === 'connectionRefused') {
                        this.modalText = this.$t('connectionRefused')
                        this.$bvModal.show('modal_show')
                    }
                    this.isLoading = false
                })
        },
    },
    mounted() {
        if (localStorage.getItem('reloaded')) {
            localStorage.removeItem('reloaded');
        } else {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }

        if (this.$route.query.p === undefined) {
            this.modelForm.partnerId = getPartner() ? getPartner() : null
        } else {
            setPartner(this.$route.query.p)
            this.modelForm.partnerId = getPartner()
        }
    },
    components: {PromoLanguageSwitcher, Modal}
}
</script>

<style scoped>
/* font style*/
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

template {
    scroll-behavior: smooth;
}

/* Shared css */
.promoPage {
    font-family: Montserrat, sans-serif;
}

::-webkit-scrollbar {
    width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
    background: rgb(235, 226, 227);
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #8300C5;
    height: 200px;
    border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #6652B2;
}

a:hover {
    text-decoration: none;
}

.bg-local {
    background-color: #F2EDF4;
}

.nav-item {
    list-style: none !important;
}

.local-button {
    color: white;
    font-size: 1rem;
    font-weight: 600;
    background-color: #8300C5;
    border: 1px solid #8300C5;
    border-radius: 5px;
}

.local-button:hover {
    background-color: white;
    color: #8300C5;
}

.local-link {
    transition: all 0.3s;
    color: #7F05C8;
}

.local-link:hover {
    color: #450a67;
}

.local-bg {
    background-color: #8300C5;
}

.btn_borderless {
    border: none;
    background-color: white;
}

table td {
    line-height: 40px;
}

/*Header*/
.header-link {
    font-size: 1rem;
    line-height: 1.25rem;
    color: #000000 !important;
}

.vr::before {
    content: "";
    border-left: 2px solid #E3E3E3;
    margin-right: 25px;
}

/*sidebar offcanvas*/
.sidenav-shadow {
    height: 100%;
    width: 0;
    z-index: 15;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.4);
}

.sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 20;
    top: 0;
    left: 0;
    background-color: #8300C5;
    overflow-x: hidden;
    padding-top: 60px;
    transition: 0.3s;
}

.sidenav-footer {
    width: 100%;
}

/* The navigation menu links */
.sidenav a {
    padding: 8px 8px 8px 24px;
    text-decoration: none;
    font-size: 16px;
    line-height: 30px;
    color: white;
    display: block;
    transition: 0.3s;
}

.top-border {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.sidenav-link {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

/* Position and style the close button (top right corner) */
.sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}

/* Media query for sidenav*/
@media screen and (max-height: 450px) {
    .sidenav {
        padding-top: 15px;
    }

    .sidenav a {
        font-size: 18px;
    }
}

/* Intro*/
.intro {
    border: none;
}

ul {
    list-style-image: url('../../public/images/true.svg');
}

/* Business */
.business-card__title {

}

.business-card__text {
    font-size: 1.25rem;
    line-height: 1.5rem;
}

.business-card__item {
    height: 50px;
    border: 1px solid #E3E3E3;
    transition: all 0.3s ease-out;
}


.business-card__item:hover {
    border-color: #8300C5;
    color: #8300C5;
    transform: scale(105%);
    fill: #8300C5;
}

.business-card__item path {
    transition: all 0.3s ease-out;
}

.business-card__item:hover path {
    fill: #8300C5;
}

/* Components */
.card {
    border: none;
}

.custom-title, .intro-title {
    font-weight: 600;
    font-size: 1.875rem;
    line-height: 2.375rem;
    margin-bottom: 20px;
    color: black;
}

.custom-text {
    font-size: 1rem;
    line-height: 1.625rem;
    color: black;
}

.component img {
    max-width: 100%;
}

.component-name {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: #959595;
}

.border-bottom-1 {
    border-bottom: 0.5px solid #C6C6C6;
}

/*Products*/
.product-tabs {
    max-height: 120px;
    height: 120px;
    overflow: hidden;
    overflow-y: scroll;
}

.product-tabs::-webkit-scrollbar {
    display: none;
}

.nav-item button {
    border: none;
    padding-right: 0;
    padding-left: 0;
    font-size: 1rem;
    line-height: 1.25rem;
    background: white;
}

button.active {
    color: #86217D;
    border-bottom: 2px solid #86217D;
}

/* Prices */

.payment-term {
    font-size: 1rem;
    line-height: 1.125rem;
    font-weight: 600;
    color: #000000;
}

.payment-method__name {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default radio button */
.payment-method__name input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
    box-sizing: border-box;
    height: 36px;
    width: 108px;
    border-top: 1px solid #CBCBCB;
    border-left: 1px solid #CBCBCB;
    border-bottom: 1px solid #CBCBCB;
    margin-left: -30px;
    text-align: center;
    border-radius: 9px 0 0 9px;
    font-size: 1rem;
    font-weight: 600;
    color: #000000;
    line-height: 36px;
}

.yearly {
    border-right: 1px solid #CBCBCB;
    border-radius: 0 9px 9px 0;
    margin-left: -35px;
}

.payment-method__name input:checked ~ .checkmark {
    background-color: #8300C5;
    border-top: 1px solid #8300C5;
    border-right: 1px solid #8300C5;
    border-bottom: 1px solid #8300C5;
    border-left: 1px solid #8300C5;
    color: white;
}

.plans-title {
    font-weight: 600;
    font-size: 40px;
    line-height: 49px;
}

.plans-name {
    color: #FFFFFF;
    height: 36px;
    vertical-align: center;
    font-weight: 600;
    font-size: 1rem;
    line-height: 2.125rem;
    text-align: center;
}

.plans-text {
    font-size: 1.25rem;
    line-height: 2.25rem;
    color: black;
}

.plans-type {
    vertical-align: center;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
}

.plans-price {
    vertical-align: center;
    font-weight: 600;
    font-size: 1.5rem;
    /*line-height: 1.8125rem;*/
    letter-spacing: -1px;
    text-align: center;
}

.plans-price__text {
    vertical-align: center;
    font-size: 0.75rem;
    /*line-height: 1rem;*/
    letter-spacing: -1px;
    text-align: center;
}

.lite {
    background-color: #6652B2;
}

.standard {
    background-color: #723999;
}

.premium {
    background-color: #86217D;
}

/* Services styles*/
.service-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1.25rem;
    border-radius: calc(0.25rem - 1px);
    background-color: rgb(0, 0, 0, 0.4);
    transition: all 0.3s;
}

.service-overlay:hover {
    background-color: rgb(0, 0, 0, 0.2);
}

/* Social Networks styles*/
.social-network {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 30px;
}

.social-network a {
    width: 160px;
}

.social-network span {
    margin-left: 10px;
}

/* Modals styles*/

.modal div {
    border-bottom: 1px solid #898989;
}

.modal svg {
    align-self: center;
}

.modal input {
    width: 100%;
    height: 50px;
    display: block;
    padding: 10px;
    color: #898989;
    border: 0;
    transition: all 0.3s linear;

}

.no-outline:focus {
    outline: none;
}


/* Media queries */
@media screen and (max-width: 350px) {
    html {
        font-size: 12px;
    }
}

@media screen and (max-width: 768px) {
    /*Components */
    .component img {
        width: 100%;
    }
}

@media screen and (min-width: 768px) {
    .business-card__item {
        height: 80px;
    }

    .custom-title, .intro-title {
        font-size: 2rem;
    }

    .component-name {
        font-size: 1.25rem;
        line-height: 1.5rem;
    }

    /*Components */
    .component img {
        border-radius: 20px;
    }

    /* Products */
    .nav-item button {
        margin-right: 20px;
    }

    /* Prices */
    .price-header {
        border-radius: 20px !important;
    }

    .lite {
        width: 70px;
    }

    .standard {
        width: 100px;
    }

    .premium {
        width: 110px;
    }

}

@media screen and (min-width: 992px) {
    .business-card__item {
        height: 100px;
        border-radius: 12px !important;
    }

    .try-it__title {
        font-size: 2.125rem;
        line-height: 3rem;
    }

    /* Products */
    .nav-item button {
        margin-right: 25px;
    }

    /* Prices */
    .plans-details {
        width: 95%;
    }

}

@media screen and (min-width: 1200px) {
    .business-card__item {
        height: 133px;
    }

    .component-name {
        font-size: 1.25rem;
        line-height: 1.5rem;
    }

    .try-it__title {
        font-size: 2.5rem;
        line-height: 5rem;
    }

    /* Products */
    .nav-item button {
        margin-right: 40px;
    }

    /* Prices */
    .plans-details {
        width: 85%;
    }

    .lite {
        width: 112px;
    }

    .standard {
        width: 151px;
    }

    .premium {
        width: 156px;
    }
}

@media screen and (min-width: 1520px) {
    /*Components*/
    .custom-title {
        font-size: 2.5rem;
        line-height: 3.0625rem;
    }

    .intro-title {
        font-size: 2.5rem;
        line-height: 5rem;
    }

    .width-90 {
        width: 90%;
    }

}

</style>
